const translations = {
    fr: {
        translation: {
            loading: "Chargement",
            address: "Adresse de la borne",
            choose_connector: "Choisissez une prise",
            choose_connector_resume: "Quelle recharge souhaitez-vous reprendre ?",
            your_connector: "Votre prise",
            connector: "Connecteur {{number}}",
            available: "Disponible",
            unavailable: "Indisponible",
            in_charge: "En charge",
            next: "Suivant",
            vehicle_plugged: "véhicule branché",

            // Messages de traitement
            processing: {
                initializing: "Initialisation du paiement...",
                verifying: "Vérification en cours...",
                creatingPayment: "Création du moyen de paiement...",
                setupPayment: "Configuration du paiement...",
                confirmingPayment: "Confirmation du paiement...",
                authorizing: "Autorisation en cours...",
                startingCharge: "Démarrage de la charge..."
            },

            // Paiement
            recapitulation: "Récapitulatif de votre session",
            Tarif: "Tarif",
            pay: "Payer",
            email: "Adresse e-mail",
            enterEmail: "Entrez votre adresse e-mail",
            securePayment: "Paiement 100% sécurisé",
            pleaseWait: "Veuillez patienter ...",
            paymentPreparing: "Préparation du paiement ...",
            plugBeforePayment: "Assurez-vous d'avoir branché votre véhicule avant de lancer la recharge.",
            emailLabel: "Adresse e-mail*",
            emailHelp: "Votre e-mail est requis pour recevoir le reçu.",
            cardNumber: "Numéro de carte*",
            ccv: "CCV*",
            exp: "Date d'expiration*",
            preAuthButton: "Pré-autorisation (40€)",
            preAuthNotice: "Une <0>pré-autorisation de 40 €</0> sera effectuée, mais seul le montant exact de votre recharge sera prélevé. Le solde non utilisé sera automatiquement libéré sous 24h.",
            chargeLimitNotice: "Votre recharge s'arrêtera lorsqu'elle atteindra le montant de 40 €.",
            missingPaymentId: "Données manquantes : ID de paiement introuvable",
            modalTitle: "Votre véhicule est-il branché ?",
            cancel: "Annuler",
            confirmationModalTitle: "Vous devez brancher votre véhicule avant de lancer la recharge.",
            notYet: "Ce n'est pas fait",
            done: "C'est fait",
            yes: "Oui",
            no: "Non",
            cardInformation: "Informations de la carte",
            payButton: "Payer",
            paymentNotice: "Vos informations de paiement sont sécurisées et ne seront pas stockées.",

            // Infos
            preAuthValidated: "Pré-autorisation validée",
            chargingWillStart: "Votre recharge va commencer",
            startCharging: "Lancer la recharge",

            startCharging: {
                launching: "Lancement de la recharge ...",
                launched: "Recharge lancée",
                ended: "Recharge terminée",
                ticket: {
                    download: "Télécharger mon ticket",
                    preparing: "Préparation du ticket...",
                    errors: {
                        notAvailableYet: "Votre justificatif n'est pas encore disponible. Réessayez dans quelques instants.",
                        notFound: "Aucun justificatif n'a été trouvé pour cette recharge.",
                        temporarilyUnavailable: "Le téléchargement est momentanément indisponible. Réessayez plus tard."
                    }
                },
                chargingStation: "Borne de recharge",
                connector: "Connecteur",
                transactionInfo: "Informations de la transaction",
                status: "Statut",
                energy: "Énergie consommée",
                duration: "Durée",
                chargeEnded: "Charge terminée",
                chargeInProgress: "En charge",
                stopCharge: "Arrêter la charge",
                stoppingCharge: "Arrêt en cours...",
                confirmStopCharge: "Confirmer l'arrêt de la charge",
                confirmStopChargeMessage: "Êtes-vous sûr de vouloir arrêter la charge ? Cette action ne peut pas être annulée.",
                unlockConnector: "Débloquer le câble",
                unlocking: "Déblocage en cours...",
                confirmUnlock: "Confirmer le Déblocage",
                confirmUnlockMessage: "Êtes-vous sûr de vouloir débloquer le câble ?",
                cancel: "Annuler",
                confirm: "Confirmer",
                errors: {
                    missingInfo: "Informations manquantes",
                    missingInfoMessage: "Les informations nécessaires pour démarrer une session de charge sont manquantes. Veuillez réessayer depuis le début.",
                    missingStopInfo: "Informations manquantes pour arrêter la charge",
                },
                apiError: "❌ Une erreur est survenue. Veuillez réessayer.",
                unlock: {
                    sentTitle: "Demande envoyée à la borne",
                    sentText: "Le câble se libère dans quelques secondes. Retirez-le de la borne puis de votre véhicule.",
                    releasedTitle: "Câble retiré",
                    releasedText: "Vous pouvez fermer cette page. Votre justificatif vous a été envoyé par e-mail.",
                    stillLockedTitle: "Le câble est toujours bloqué ?",
                    stillLockedText: "Réessayez le déblocage. Si le câble reste bloqué, contactez le service client en indiquant :",
                    retry: "Réessayer le déblocage",
                    stationLine: "Borne {{station}} · {{connector}}",
                    transactionLine: "Transaction n° {{transaction}}",
                },
                connecting: {
                    title: "Connexion à la borne…",
                    text: "Nous vérifions que la borne est prête à démarrer. Cela prend quelques secondes.",
                    plugTitle: "Votre véhicule doit être branché",
                    plugText: "Si ce n'est pas encore fait, branchez le câble à la borne et à votre véhicule. Si la prise est sous trappe, elle se déverrouille maintenant.",
                },
                startFailed: {
                    title: "La recharge ne se lance pas",
                    subtitle: "Contactez le service client, nous vous aidons à démarrer.",
                    noCharge: "Aucun montant n'est débité.",
                    preauthRelease: "La préautorisation de 40 € est annulée automatiquement au bout d'1 heure maximum.",
                    checklistTitle: "À vérifier en attendant",
                    checkCable: "Le câble est bien enclenché des deux côtés",
                    checkSchedule: "Le véhicule n'est pas verrouillé en charge programmée",
                    retry: "Réessayer le démarrage",
                },
                charging: {
                    status: "En charge",
                    energyUnit: "kWh rechargés",
                    duration: "Durée",
                    pricePerKwh: "Prix par kWh",
                    canCloseTitle: "Vous pouvez fermer cette page",
                    followLink: "Suivez la recharge via le lien envoyé à {{email}}",
                    followLinkNoEmail: "Suivez la recharge via le lien envoyé par e-mail",
                    rescan: "Ou scannez à nouveau la borne et saisissez les 4 derniers chiffres de votre carte",
                    stop: "Arrêter la recharge",
                    stopping: "Arrêt en cours…",
                    confirmStopTitle: "Arrêter la recharge ?",
                    confirmStopText: "Seule l'énergie consommée sera débitée. Vous pourrez ensuite débloquer le câble.",
                    confirmStop: "Arrêter maintenant",
                    cancel: "Continuer la recharge",
                },
                completed: {
                    title: "Recharge terminée",
                    amountDebited: "Montant débité",
                    amountPending: "Calcul en cours",
                    energy: "Énergie",
                    duration: "Durée",
                    released: "{{amount}} libérés automatiquement, délai selon votre banque",
                    receiptTitle: "Votre justificatif",
                    receiptSent: "Envoyé à {{email}}. Vous pouvez aussi le télécharger ici.",
                    receiptSentNoEmail: "Envoyé par e-mail. Vous pouvez aussi le télécharger ici.",
                    receiptPending: "Il vous sera envoyé à {{email}} dès qu'il sera disponible.",
                    receiptPendingNoEmail: "Il vous sera envoyé par e-mail dès qu'il sera disponible.",
                    download: "Télécharger mon justificatif",
                    preparing: "Téléchargement en cours…",
                    unlock: "Débloquer le câble",
                    confirmUnlockTitle: "Débloquer le câble ?",
                    confirmUnlockText: "La borne va libérer le câble. Retirez-le ensuite de la borne puis de votre véhicule.",
                    confirmUnlock: "Débloquer",
                    amountPendingReleased: "Le reste des 40 € sera libéré automatiquement, délai selon votre banque",
                    downloadFailed: "Le téléchargement a échoué. Votre justificatif reste disponible dans l'e-mail reçu.",
                    retry: "Réessayer",
                    cancel: "Annuler",
                },
            },
            landing: {
                title: "Rechargez en 3 étapes",
                subtitle: "Sans compte ni application.",
                step1Title: "Payez par carte bancaire",
                step1Text: "Vous ne payez que l'énergie consommée, au tarif affiché ci-dessous.",
                step2Title: "Branchez votre véhicule",
                step2Text: "Déjà branché ? Parfait. Si la prise est sous trappe, elle se déverrouille après validation.",
                step3Title: "La recharge démarre",
                step3Text: "Automatiquement. Vous la suivez depuis cette page.",
                yourConnector: "Votre prise",
                chooseConnector: "Choisissez votre prise",
                continue: "Continuer",
            },
            emailStep: {
                title: "Votre adresse e-mail",
                subtitle: "Pour vous envoyer le lien de suivi de la recharge et votre reçu.",
                label: "Adresse e-mail",
                placeholder: "nom@exemple.fr",
                follow: "Suivre votre recharge",
                noAccount: "Aucun compte n'est créé",
                invalid: "Saisissez une adresse e-mail valide, par exemple nom@exemple.fr.",
                consent: "J'accepte les <0>Conditions Générales de Vente</0> et la <1>Politique de confidentialité</1>.",
            },
            payment: {
                title: "Paiement par carte",
                preauth: "<0>40 € temporairement</0> bloqués, <1>pas débités</1>. Seul le prix de votre recharge sera débité.",
                howItWorks: "Comment ça marche ?",
                yourCard: "Votre carte",
                secure: "Paiement sécurisé",
                cardNumber: "Numéro de carte",
                expiry: "Expiration",
                cvc: "CVC",
                acceptedCards: "Cartes françaises et étrangères acceptées",
                submit: "Valider et démarrer",
                processing: "Vérification de votre carte…",
                techError: "Une erreur technique est survenue, aucun montant n'a été bloqué. Réessayez dans quelques instants.",
            },
            howItWorks: {
                title: "Une préautorisation, pas un paiement",
                subtitle: "Comme à une pompe à carburant, un montant est réservé le temps de la recharge.",
                startTitle: "Au démarrage",
                startText: "Votre banque réserve 40 €. Rien n'est débité.",
                duringTitle: "Pendant la recharge",
                duringText: "Elle s'arrête d'elle-même à 40 €.",
                endTitle: "À la fin",
                endText: "Seul le prix de la recharge est débité. Le reste est libéré automatiquement, <0>dans un délai qui dépend de votre banque</0>.",
                example: "Exemple",
                exampleCharged: "12 kWh rechargés",
                exampleDebited: "{{amount}} débités",
                exampleReleased: "Libéré",
                gotIt: "J'ai compris",
            },
            refused: {
                title: "Votre carte a été refusée",
                subtitle: "Aucun montant n'a été débité.",
                generic: "Votre banque n'a pas accepté la préautorisation de 40 €. Vérifiez le plafond de votre carte ou que les paiements en ligne sont activés.",
                insufficientFunds: "Le solde ou le plafond de votre carte ne permet pas de bloquer 40 €. Essayez une autre carte ou contactez votre banque.",
                expiredCard: "Votre carte est expirée. Essayez une autre carte.",
                incorrectCvc: "Le code de sécurité (CVC) saisi est incorrect. Vérifiez les 3 chiffres au dos de votre carte, puis réessayez.",
                authentication: "La validation auprès de votre banque (3D Secure) n'a pas abouti. Réessayez et confirmez le paiement dans l'application de votre banque.",
                tryAnother: "Essayer une autre carte",
                useApp: "Utiliser l'application Qovoltis",
                needHelp: "Besoin d'aide ?",
            },
            invoice: {
                title: "Facture nominative",
                intro: "Ces informations apparaîtront sur votre facture, envoyée à {{email}}.",
                introNoEmail: "Ces informations apparaîtront sur votre facture, envoyée par e-mail.",
                lastName: "Nom",
                firstName: "Prénom",
                address: "Adresse",
                addressPlaceholder: "12 rue de la Paix, 75002 Paris",
                required: "* Champs obligatoires",
                fieldRequired: "Champ obligatoire",
                addressPick: "Choisissez une adresse dans la liste.",
                save: "Enregistrer",
                noInvoice: "Je ne souhaite pas de facture",
                noInvoiceTitle: "Continuer sans facture ?",
                noInvoiceText: "Vous recevrez uniquement un reçu par e-mail. Vous ne pourrez pas obtenir de facture nominative pour cette recharge.",
                noInvoiceConfirm: "Oui, continuer sans facture",
                cancel: "Annuler",
                needInvoice: "Besoin d'une facture nominative ?",
                addDetails: "Ajouter mes coordonnées",
                saved: "Vos coordonnées figureront sur votre facture.",
                saveError: "Vos coordonnées n'ont pas pu être enregistrées.",
                savedDetail: "{{name}} · {{address}}",
                retry: "Réessayer",
            },
            language: {
                title: "Langue",
                new: "Nouveau",
            },
            loadingStation: {
                title: "Chargement de la borne…",
                text: "Nous récupérons les prises et le tarif.",
            },
            linkLoading: {
                title: "Chargement de votre recharge…",
                text: "Ouverture du lien de suivi reçu par e-mail.",
            },
            ineligible: {
                title: "Cette borne n'accepte pas le paiement par carte",
                text: "Vous pouvez la démarrer depuis l'application Qovoltis, en quelques minutes.",
            },
            errorPage: {
                text: "Aucun montant n'a été débité. Réessayez ou scannez à nouveau le QR code de la borne.",
                retry: "Réessayer",
            },
            notFoundPage: {
                title: "Page introuvable",
                text: "Cette adresse ne correspond à aucune borne. Scannez à nouveau le QR code affiché sur la borne.",
            },
            linkInvalid: {
                text: "Pour retrouver une recharge en cours, scannez à nouveau la borne et saisissez les 4 derniers chiffres de votre carte.",
            },
            resumeList: {
                subtitle: "Plusieurs recharges sont en cours sur cette borne. Choisissez la prise sur laquelle votre véhicule est branché.",
            },
            busy: {
                title: "Cette prise est occupée",
                subtitle: "Une recharge est en cours sur cette borne.",
                yoursTitle: "C'est votre recharge ?",
                yoursText: "Suivez-la ou arrêtez-la depuis votre téléphone.",
                find: "Retrouver ma recharge",
                later: "Sinon, revenez scanner la borne une fois la prise libérée.",
            },
            intent: {
                title: "Que souhaitez-vous faire ?",
                subtitle: "Une recharge est déjà en cours sur cette borne.",
                startTitle: "Démarrer une recharge",
                startText: "Une prise est disponible",
                resumeTitle: "Reprendre ma recharge",
                resumeText: "Suivre ou arrêter la recharge en cours",
            },
            common: {
                back: "Retour",
                close: "Fermer",
            },
            steps: {
                connector: "Prise",
                email: "E-mail",
                payment: "Paiement",
            },
            panel: {
                station: "Votre borne",
                summary: "Récapitulatif",
                charge: "Votre recharge",
                address: "Adresse",
                connector: "Prise",
                rate: "Tarif",
                preauth: "Préautorisation",
                preauthValue: "40 € bloqués, pas débités",
                connectorsCount: "{{count}} prises",
            },
            support: {
                whatsapp: "Écrire au service client",
                call: "Appeler le service client",
                orCall: "Ou appeler le service client",
                whatsappMessage: "Bonjour, j'ai besoin d'aide pour ma recharge. Borne {{station}}, prise {{connector}}, {{time}}.",
                whatsappMessageTransaction: "Bonjour, j'ai besoin d'aide pour ma recharge. Borne {{station}}, prise {{connector}}, transaction {{transaction}}, {{time}}.",
            },
            downloadApp: {
                title: "Gérez vos recharges plus simplement avec notre application mobile",
                description: "Suivez vos recharges, consultez vos factures et retrouvez facilement les bornes autour de vous, directement depuis votre smartphone.",
                downloadButton: "Télécharger l'application",
                continueWithoutApp: "Continuer sans l'application",
                features: {
                    feature1: "Rechargez en un clic",
                    feature2: "Suivez votre consommation",
                    feature3: "Trouvez toutes les bornes",
                    feature4: "Bénéficiez d'offres exclusives"
                }
            },

            // Erreurs
            errorTitle: "Erreur !",
            genericErrorTitle: "Une erreur est survenue",
            genericErrorMessage: "Erreur lors de la création de votre autorisation. Veuillez réessayer, s'il vous plaît.",
            errorIconAlt: "Icône d'erreur",
            pageNotFound: "Page non trouvée ou numéro de série invalide",
            noBorneData: "Données de la borne manquantes.",
            errors: {
                // Erreurs HTTP
                badRequest: "La requête est invalide. Veuillez vérifier les informations saisies.",
                unauthorized: "Vous n'êtes pas autorisé à effectuer cette action. Veuillez vous reconnecter.",
                forbidden: "Accès refusé. Vous n'avez pas les permissions nécessaires.",
                notFound: "La ressource demandée n'a pas été trouvée.",
                requestTimeout: "La demande a expiré. Veuillez réessayer.",
                conflict: "Un conflit a été détecté. Veuillez actualiser la page et réessayer.",
                validationError: "Les données saisies sont invalides. Veuillez vérifier les champs.",
                tooManyRequests: "Trop de tentatives. Veuillez réessayer plus tard.",
                serverError: "Le serveur rencontre un problème technique. Veuillez réessayer plus tard.",
                badGateway: "Un problème de communication entre serveurs est survenu. Veuillez réessayer plus tard.",
                serviceUnavailable: "Le service est temporairement indisponible. Veuillez réessayer plus tard.",
                gatewayTimeout: "Le délai d'attente du serveur a été dépassé. Veuillez réessayer plus tard.",

                // Erreurs générales
                networkError: "Problème de connexion réseau. Vérifiez votre connexion Internet et réessayez.",
                unknownError: "Une erreur inattendue est survenue. Veuillez réessayer plus tard.",
                methodNotAllowed: "La méthode de requête n'est pas autorisée pour cette ressource.",
                invoiceError: "Une erreur est survenue lors de l'envoi de la facture. Veuillez réessayer.",
                chargingStationNotFound: "Borne non trouvée",

                // Erreurs spécifiques
                stripeError: "Une erreur est survenue lors du traitement de votre paiement. Veuillez vérifier vos informations et réessayer.",
                recaptchaFailed: "La vérification de sécurité a échoué. Veuillez réessayer.",
                recaptchaExpired: "La vérification de sécurité a expiré. Veuillez réessayer.",
                chargingFailed: "Le démarrage de la charge a échoué. Veuillez réessayer ou contacter le support.",

                invalidResponse: "Erreur réseau ou réponse invalide du serveur",
                authorizationFailed: "Échec de création de l'autorisation de paiement.",
                paymentInitFailed: "Nous n'avons pas pu initialiser le paiement sécurisé. Veuillez réessayer.",
                insufficientFunds: "Vous ne pouvez pas utiliser cette carte car le solde est insuffisant. Veuillez essayer avec une autre carte.",
                errorAttachingPayment: "Une erreur est survenue lors de l'enregistrement de votre moyen de paiement. Veuillez réessayer.",
                cardDeclined: "Votre carte a été refusée. Veuillez vérifier vos informations ou utiliser une autre carte.",
                expiredCard: "Votre carte a expiré. Veuillez utiliser une carte valide.",
                incorrectCvv: "Le code de sécurité (CVV) est incorrect. Veuillez vérifier et réessayer.",
                processingError: "Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer.",
                emailRequired: "Veuillez renseigner votre adresse e-mail.",
                emailInvalid: "Veuillez entrer une adresse email valide",
                invalidEmail: "Veuillez entrer une adresse e-mail valide.",
                apiError: "❌ Une erreur est survenue. Veuillez réessayer.",

                stripeCustomerNotFound: "Nous n'avons pas pu trouver votre client Stripe et n'avons pas pu en créer un nouveau",
                countryNotFound: "Le pays spécifié n'a pas été trouvé",
                postalCodeNotFound: "Le code postal spécifié n'a pas été trouvé",
                noOngoingTransaction: "Aucune transaction en cours trouvée pour cet utilisateur",
                transactionClosed: "Cette transaction a déjà été clôturée",
                noAuthorizationFound: "Aucune autorisation de carte de crédit trouvée pour cette transaction",
                authorizationNotFound: "L'autorisation spécifiée n'a pas été trouvée",
                authorizationNotFoundInDB: "L'autorisation spécifiée n'a pas été trouvée dans la base de données",
                updatingAuthorizationError: "Une erreur est survenue lors de la mise à jour de l'autorisation",
                noDefaultCreditCard: "L'utilisateur n'a pas de carte de crédit par défaut",
                evcpNotFound: "La borne de recharge spécifiée n'a pas été trouvée",
                connectorNotFound: "Le connecteur spécifié n'a pas été trouvé sur cette borne",
                useridTagNotFound: "L'identifiant utilisateur n'a pas été trouvé",
                failedAssociateUser: "Échec de l'association de l'utilisateur",
                internalError: "Erreur interne. Veuillez réessayer",
                noOngoingCpSession: "Aucune session de charge en cours pour cet utilisateur. Vérifiez que la borne est en ligne et que votre session est valide",
                remoteStartDenied: "Démarrage à distance refusé",
                kafkaError: "Erreur inattendue lors de l'envoi à Kafka",
                transactionNotAssociated: "La transaction n'est pas associée à la borne spécifiée",
                cpDisconnected: "La borne de recharge est déconnectée",

            },
            access_denied_no_session: "Accès refusé : aucune session de recharge trouvée.",
            notEligibleForOneClick: "Cette borne n'est pas éligible au Scan to Charge. Veuillez télécharger notre application pour continuer.",
            storeRedirect: {
                downloadTitle: "Téléchargez notre application",
                downloadDescription: "Pour une meilleure expérience, téléchargez l'application Qovoltis."
            },
            sessionChoice: {
                title: "Une recharge est en cours sur cette borne",
                question: "Que souhaitez-vous faire ?",
                startNew: {
                    title: "Lancer une nouvelle recharge",
                    description: "Choisissez un connecteur disponible et branchez votre véhicule.",
                    noConnectorAvailable: "Aucun connecteur n'est disponible sur cette borne pour le moment."
                },
                resume: {
                    title: "Reprendre ma recharge en cours",
                    description: "Suivez ou arrêtez la recharge que vous avez déjà lancée."
                }
            },
            resumeSession: {
                findTitle: "Retrouver ma recharge",
                findSubtitle: "Saisissez les 4 derniers chiffres de la carte utilisée pour payer.",
                emailLinkHint: "Vous pouvez aussi utiliser le lien de suivi reçu par e-mail.",
                access: "Accéder à ma recharge",
                digitLabel: "Chiffre {{position}} sur 4",
                title: "Reprise de session",
                sessionActive: "Une recharge est en cours sur ce connecteur.",
                cta: "Reprendre ma session",
                cardLabel: "Saisissez les 4 derniers chiffres de la carte utilisée",
                validate: "Valider",
                verifying: "Vérification...",
                errors: {
                    invalidFormat: "Veuillez saisir les 4 derniers chiffres de votre carte.",
                    wrongCard: "Code incorrect. Il vous reste {{count}} tentative(s).",
                    tooManyAttempts: "Trop de tentatives. Veuillez réessayer plus tard.",
                    wrongDigits: "Ces chiffres ne correspondent pas à la recharge en cours. Vérifiez la carte utilisée.",
                    missingInfo: "Informations de session manquantes.",
                    invalidLink: "Ce lien est invalide ou a expiré.",
                    generic: "Une erreur est survenue. Veuillez réessayer."
                }
            },
            chargingStarted: "Recharge démarrée avec succès",
            chargingStationInfo: "Informations de la borne",
            connectorInfo: "Informations du connecteur"
        }
    },
    en: {
        translation: {
            loading: "Loading",
            address: "Station address",
            choose_connector: "Choose a plug",
            choose_connector_resume: "Which charging session would you like to resume?",
            your_connector: "Your plug",
            connector: "Connector {{number}}",
            available: "Available",
            unavailable: "Unavailable",
            in_charge: "Charging",
            next: "Next",
            vehicle_plugged: "vehicle plugged",

            // Processing messages
            processing: {
                initializing: "Initializing payment...",
                verifying: "Verification in progress...",
                creatingPayment: "Creating payment method...",
                setupPayment: "Setting up payment...",
                confirmingPayment: "Confirming payment...",
                authorizing: "Authorizing...",
                startingCharge: "Starting charge..."
            },

            // Payment
            recapitulation: "Session Summary",
            Tarif: "Pricing",
            pay: "Pay",
            email: "Email address",
            enterEmail: "Enter your email address",
            securePayment: "100% secure payment",
            pleaseWait: "Please wait ...",
            paymentPreparing: "Preparing payment ...",
            plugBeforePayment:
                "Make sure your vehicle is plugged in before starting charge.",
            emailLabel: "Email address is required",
            emailHelp: "Your email is needed to receive receipt.",
            cardNumber: "Card number",
            ccv: "CCV*",
            exp: "EXP",
            preAuthButton: "Pre-authorization (€40)",
            preAuthNotice:
                "A <0>pre-authorization of €40</0> will be temporarily blocked. Only the exact amount of your charging session will be debited. The remainder will be released within 72 working hours.",
            chargeLimitNotice: "Your charging session will stop if it reaches the amount of €40.",
            missingPaymentId: "Missing data: payment ID not found.",
            modalTitle: "Is your vehicle plugged in?",
            cancel: "Cancel",
            confirmationModalTitle: "You must plug in your vehicle before starting charging.",
            notYet: "Not yet done",
            done: "Done",
            yes: "Yes",
            no: "No",
            cardInformation: "Card information",
            payButton: "Pay",
            paymentNotice: "Your payment information is secure and will not be stored.",

            // Infos
            preAuthValidated: "Pre-authorization validated",
            chargingWillStart: "Your charging session will start",
            startCharging: "Start charging",

            startCharging: {
                launching: "Starting charging ...",
                launched: "Charging launched",
                ended: "Charging ended",
                ticket: {
                    download: "Download my receipt",
                    preparing: "Preparing your receipt...",
                    errors: {
                        notAvailableYet: "Your receipt is not available yet. Please try again in a moment.",
                        notFound: "No receipt was found for this charging session.",
                        temporarilyUnavailable: "Downloads are temporarily unavailable. Please try again later."
                    }
                },
                chargingStation: "Charging station",
                connector: "Connector",
                transactionInfo: "Transaction Information",
                status: "Status",
                energy: "Energy Consumed",
                duration: "Duration",
                chargeEnded: "Charge ended",
                chargeInProgress: "Charging",
                stopCharge: "Stop charging",
                stoppingCharge: "Stopping...",
                confirmStopCharge: "Confirm stop charging",
                confirmStopChargeMessage: "Are you sure you want to stop charging? This action cannot be undone.",
                unlockConnector: "Unlock the cable",
                unlocking: "Unlocking the cable...",
                confirmUnlock: "Confirm Unlock",
                confirmUnlockMessage: "Are you sure you want to unlock the cable?",
                cancel: "Cancel",
                confirm: "Confirm",
                errors: {
                    missingInfo: "Missing information",
                    missingInfoMessage: "The necessary information to start a charging session is missing. Please try again from the beginning.",
                    missingStopInfo: "Missing information to stop charging",
                },
                apiError: "❌ An error occurred. Please try again.",
                unlock: {
                    sentTitle: "Request sent to the charging station",
                    sentText: "The cable will be released in a few seconds. Remove it from the charging station, then from your vehicle.",
                    releasedTitle: "Cable removed",
                    releasedText: "You can close this page. Your receipt has been sent to you by email.",
                    stillLockedTitle: "Cable still locked?",
                    stillLockedText: "Try unlocking again. If the cable stays locked, contact customer service and give them:",
                    retry: "Try unlocking again",
                    stationLine: "Station {{station}} · {{connector}}",
                    transactionLine: "Transaction no. {{transaction}}",
                },
                connecting: {
                    title: "Connecting to the charging station…",
                    text: "We are checking that the charging station is ready to start. This takes a few seconds.",
                    plugTitle: "Your vehicle must be plugged in",
                    plugText: "If you haven't already, plug the cable into the charging station and your vehicle. If the socket is behind a flap, it unlocks now.",
                },
                startFailed: {
                    title: "Charging won't start",
                    subtitle: "Contact customer service, we'll help you get started.",
                    noCharge: "Nothing has been debited.",
                    preauthRelease: "The €40 pre-authorization is automatically cancelled within 1 hour at most.",
                    checklistTitle: "Things to check in the meantime",
                    checkCable: "The cable is firmly plugged in at both ends",
                    checkSchedule: "The vehicle is not locked into scheduled charging",
                    retry: "Try starting again",
                },
                charging: {
                    status: "Charging",
                    energyUnit: "kWh charged",
                    duration: "Duration",
                    pricePerKwh: "Price per kWh",
                    canCloseTitle: "You can close this page",
                    followLink: "Follow your charging session via the link sent to {{email}}",
                    followLinkNoEmail: "Follow your charging session via the link sent by email",
                    rescan: "Or scan the charging station again and enter the last 4 digits of your card",
                    stop: "Stop charging",
                    stopping: "Stopping…",
                    confirmStopTitle: "Stop charging?",
                    confirmStopText: "Only the energy consumed will be debited. You can then unlock the cable.",
                    confirmStop: "Stop now",
                    cancel: "Keep charging",
                },
                completed: {
                    title: "Charging complete",
                    amountDebited: "Amount debited",
                    amountPending: "Being calculated",
                    energy: "Energy",
                    duration: "Duration",
                    released: "{{amount}} released automatically, timing depends on your bank",
                    receiptTitle: "Your receipt",
                    receiptSent: "Sent to {{email}}. You can also download it here.",
                    receiptSentNoEmail: "Sent by email. You can also download it here.",
                    receiptPending: "It will be sent to {{email}} as soon as it is available.",
                    receiptPendingNoEmail: "It will be sent by email as soon as it is available.",
                    download: "Download my receipt",
                    preparing: "Downloading…",
                    unlock: "Unlock the cable",
                    confirmUnlockTitle: "Unlock the cable?",
                    confirmUnlockText: "The charging station will release the cable. Then remove it from the station and from your vehicle.",
                    confirmUnlock: "Unlock",
                    amountPendingReleased: "The rest of the €40 will be released automatically, timing depends on your bank",
                    downloadFailed: "The download failed. Your receipt is still available in the email you received.",
                    retry: "Try again",
                    cancel: "Cancel",
                },
            },
            landing: {
                title: "Charge in 3 steps",
                subtitle: "No account or app needed.",
                step1Title: "Pay by card",
                step1Text: "You only pay for the energy you use, at the rate shown below.",
                step2Title: "Plug in your vehicle",
                step2Text: "Already plugged in? Great. If the socket is behind a flap, it unlocks after confirmation.",
                step3Title: "Charging starts",
                step3Text: "Automatically. You can follow it from this page.",
                yourConnector: "Your connector",
                chooseConnector: "Choose your connector",
                continue: "Continue",
            },
            emailStep: {
                title: "Your email address",
                subtitle: "To send you the charging tracking link and your receipt.",
                label: "Email address",
                placeholder: "name@example.com",
                follow: "Follow your charging session",
                noAccount: "No account is created",
                invalid: "Enter a valid email address, for example name@example.com.",
                consent: "I accept the <0>Terms and Conditions of Sale</0> and the <1>Privacy Policy</1>.",
            },
            payment: {
                title: "Card payment",
                preauth: "<0>€40 temporarily</0> held, <1>not debited</1>. Only the price of your charging session will be debited.",
                howItWorks: "How does it work?",
                yourCard: "Your card",
                secure: "Secure payment",
                cardNumber: "Card number",
                expiry: "Expiry",
                cvc: "CVC",
                acceptedCards: "French and foreign cards accepted",
                submit: "Confirm and start",
                processing: "Checking your card…",
                techError: "A technical error occurred and nothing was held. Please try again in a moment.",
            },
            howItWorks: {
                title: "A pre-authorization, not a payment",
                subtitle: "Like at a fuel pump, an amount is reserved for the duration of the charging session.",
                startTitle: "At the start",
                startText: "Your bank reserves €40. Nothing is debited.",
                duringTitle: "During charging",
                duringText: "It stops by itself at €40.",
                endTitle: "At the end",
                endText: "Only the price of the charging session is debited. The rest is released automatically, <0>within a time that depends on your bank</0>.",
                example: "Example",
                exampleCharged: "12 kWh charged",
                exampleDebited: "{{amount}} debited",
                exampleReleased: "Released",
                gotIt: "Got it",
            },
            refused: {
                title: "Your card was declined",
                subtitle: "Nothing has been debited.",
                generic: "Your bank did not accept the €40 pre-authorization. Check your card limit or that online payments are enabled.",
                insufficientFunds: "Your card balance or limit does not allow €40 to be held. Try another card or contact your bank.",
                expiredCard: "Your card has expired. Try another card.",
                incorrectCvc: "The security code (CVC) you entered is incorrect. Check the 3 digits on the back of your card, then try again.",
                authentication: "Your bank's verification (3D Secure) was not completed. Try again and confirm the payment in your banking app.",
                tryAnother: "Try another card",
                useApp: "Use the Qovoltis app",
                needHelp: "Need help?",
            },
            invoice: {
                title: "Invoice in your name",
                intro: "This information will appear on your invoice, sent to {{email}}.",
                introNoEmail: "This information will appear on your invoice, sent by email.",
                lastName: "Last name",
                firstName: "First name",
                address: "Address",
                addressPlaceholder: "12 rue de la Paix, 75002 Paris",
                required: "* Required fields",
                fieldRequired: "Required field",
                addressPick: "Choose an address from the list.",
                save: "Save",
                noInvoice: "I don't want an invoice",
                noInvoiceTitle: "Continue without an invoice?",
                noInvoiceText: "You will only receive a receipt by email. You will not be able to get an invoice in your name for this charging session.",
                noInvoiceConfirm: "Yes, continue without an invoice",
                cancel: "Cancel",
                needInvoice: "Need an invoice in your name?",
                addDetails: "Add my details",
                saved: "Your details will appear on your invoice.",
                saveError: "Your details could not be saved.",
                savedDetail: "{{name}} · {{address}}",
                retry: "Try again",
            },
            language: {
                title: "Language",
                new: "New",
            },
            loadingStation: {
                title: "Loading the charging station…",
                text: "We are fetching the connectors and the rate.",
            },
            linkLoading: {
                title: "Loading your charging session…",
                text: "Opening the tracking link from your email.",
            },
            ineligible: {
                title: "This charging station does not accept card payment",
                text: "You can start it from the Qovoltis app in just a few minutes.",
            },
            errorPage: {
                text: "Nothing has been debited. Try again or scan the charging station's QR code again.",
                retry: "Try again",
            },
            notFoundPage: {
                title: "Page not found",
                text: "This address does not match any charging station. Scan the QR code on the charging station again.",
            },
            linkInvalid: {
                text: "To find a charging session in progress, scan the charging station again and enter the last 4 digits of your card.",
            },
            resumeList: {
                subtitle: "Several charging sessions are in progress on this station. Choose the connector your vehicle is plugged into.",
            },
            busy: {
                title: "This connector is in use",
                subtitle: "A charging session is in progress on this station.",
                yoursTitle: "Is this your charging session?",
                yoursText: "Follow or stop it from your phone.",
                find: "Find my charging session",
                later: "Otherwise, scan the station again once the connector is free.",
            },
            intent: {
                title: "What would you like to do?",
                subtitle: "A charging session is already in progress on this station.",
                startTitle: "Start charging",
                startText: "A connector is available",
                resumeTitle: "Resume my charging session",
                resumeText: "Follow or stop the session in progress",
            },
            common: {
                back: "Back",
                close: "Close",
            },
            steps: {
                connector: "Connector",
                email: "Email",
                payment: "Payment",
            },
            panel: {
                station: "Your charging station",
                summary: "Summary",
                charge: "Your charging session",
                address: "Address",
                connector: "Connector",
                rate: "Rate",
                preauth: "Pre-authorization",
                preauthValue: "€40 held, not debited",
                connectorsCount: "{{count}} connectors",
            },
            support: {
                whatsapp: "Message customer service",
                call: "Call customer service",
                orCall: "Or call customer service",
                whatsappMessage: "Hello, I need help with my charging session. Station {{station}}, connector {{connector}}, {{time}}.",
                whatsappMessageTransaction: "Hello, I need help with my charging session. Station {{station}}, connector {{connector}}, transaction {{transaction}}, {{time}}.",
            },
            downloadApp: {
                title: "Manage your charging sessions more easily with our mobile app",
                description: "Track your charging sessions, view your invoices, and easily find charging stations near you, directly from your smartphone.",
                downloadButton: "Download app",
                continueWithoutApp: "Continue without app",
                features: {
                    feature1: "Charge with one click",
                    feature2: "Track your consumption",
                    feature3: "Find all charging stations",
                    feature4: "Get exclusive offers"
                }
            },

            // Errors
            errorTitle: "Error!",
            genericErrorTitle: "An error has occurred",
            genericErrorMessage:
                "Error while creating your authorization. Please try again.",
            errorIconAlt: "Error icon",
            pageNotFound: "Page not found or invalid serial number",
            noBorneData: "Missing charging station data.",
            errors: {
                // HTTP Errors
                badRequest: "The request is invalid. Please check the entered information.",
                unauthorized: "You are not authorized to perform this action. Please log in again.",
                forbidden: "Access denied. You do not have the necessary permissions.",
                notFound: "The requested resource was not found.",
                requestTimeout: "The request has timed out. Please try again.",
                conflict: "A conflict has been detected. Please refresh the page and try again.",
                validationError: "The entered data is invalid. Please check the fields.",
                tooManyRequests: "Too many attempts. Please try again later.",
                serverError: "The server is experiencing a technical problem. Please try again later.",
                badGateway: "A communication problem between servers has occurred. Please try again later.",
                serviceUnavailable: "The service is temporarily unavailable. Please try again later.",
                gatewayTimeout: "The server took too long to respond. Please try again later.",

                // General Errors
                networkError: "Network connection problem. Check your internet connection and try again.",
                unknownError: "An unexpected error has occurred. Please try again later.",
                methodNotAllowed: "The request method is not allowed for this resource.",
                invoiceError: "An error occurred while sending the invoice. Please try again.",
                chargingStationNotFound: "Charging station not found",

                // Specific Errors
                stripeError: "An error occurred while processing your payment. Please check your information and try again.",
                recaptchaFailed: "The security verification failed. Please try again.",
                recaptchaExpired: "The security verification has expired. Please try again.",
                chargingFailed: "Starting the charge failed. Please try again or contact support.",

                invalidResponse: "Network error or invalid server response.",
                authorizationFailed: "Failed to create payment authorization.",
                paymentInitFailed: "We couldn't initialize the secure payment. Please try again.",
                insufficientFunds: "This card cannot be used due to insufficient funds. Please try using another card.",
                errorAttachingPayment: "An error occurred while saving your payment method. Please try again.",
                cardDeclined: "Your card was declined. Please check your information or use another card.",
                expiredCard: "Your card has expired. Please use a valid card.",
                incorrectCvv: "The security code (CVV) is incorrect. Please check and try again.",
                processingError: "An error occurred while processing your request. Please try again.",
                emailRequired: "Please enter your email address.",
                emailInvalid: "Please enter a valid email address",
                invalidEmail: "Please enter a valid email address.",
                apiError: "❌ An error occurred. Please try again.",


                stripeCustomerNotFound: "We could not find your Stripe customer and could not create a new one",
                countryNotFound: "The specified country was not found",
                postalCodeNotFound: "The specified postal code was not found",
                noOngoingTransaction: "No ongoing transaction found for this user",
                transactionClosed: "This transaction has already been closed",
                noAuthorizationFound: "No credit card authorization found for this transaction",
                authorizationNotFound: "The specified authorization was not found",
                authorizationNotFoundInDB: "The specified authorization was not found in the database",
                updatingAuthorizationError: "An error occurred while updating the authorization",
                noDefaultCreditCard: "User has no default credit card",
                evcpNotFound: "The specified charging station was not found",
                connectorNotFound: "The specified connector was not found on this station",
                useridTagNotFound: "User identifier not found",
                failedAssociateUser: "Failed to associate user",
                internalError: "Internal error. Please try again",
                noOngoingCpSession: "No ongoing charging session for this user. Please check if the station is online and if your session is valid",
                remoteStartDenied: "Remote start denied",
                kafkaError: "Unexpected error sending to Kafka",
                transactionNotAssociated: "The transaction is not associated with the specified station",
                cpDisconnected: "The charging station is disconnected",

            },
            access_denied_no_session: "Access denied: no charging session found.",
            notEligibleForOneClick: "This station is not eligible for Scan to Charge. Please download our app to continue.",
            storeRedirect: {
                downloadTitle: "Download our app",
                downloadDescription: "For a better experience, download the Qovoltis app."
            },
            sessionChoice: {
                title: "A charging session is in progress on this station",
                question: "What would you like to do?",
                startNew: {
                    title: "Start a new charging session",
                    description: "Pick an available connector and plug in your vehicle.",
                    noConnectorAvailable: "No connector is available on this station right now."
                },
                resume: {
                    title: "Resume my charging session",
                    description: "Track or stop the session you already started."
                }
            },
            resumeSession: {
                findTitle: "Find my charging session",
                findSubtitle: "Enter the last 4 digits of the card used to pay.",
                emailLinkHint: "You can also use the tracking link sent by email.",
                access: "Go to my charging session",
                digitLabel: "Digit {{position}} of 4",
                title: "Resume session",
                sessionActive: "A charging session is in progress on this connector.",
                cta: "Resume my session",
                cardLabel: "Enter the last 4 digits of the card you used",
                validate: "Verify",
                verifying: "Verifying...",
                errors: {
                    invalidFormat: "Please enter the last 4 digits of your card.",
                    wrongCard: "Incorrect code. You have {{count}} attempt(s) left.",
                    tooManyAttempts: "Too many attempts. Please try again later.",
                    wrongDigits: "These digits do not match the charging session in progress. Check the card you used.",
                    missingInfo: "Missing session information.",
                    invalidLink: "This link is invalid or has expired.",
                    generic: "Something went wrong. Please try again."
                }
            },
            chargingStarted: "Charging started successfully",
            chargingStationInfo: "Charging station information",
            connectorInfo: "Connector information"
        }
    },
    es: {
        translation: {
            loading: "Cargando",
            address: "Dirección de la estación",
            choose_connector: "Elija un enchufe",
            choose_connector_resume: "¿Qué recarga desea reanudar?",
            your_connector: "Su enchufe",
            connector: "Conector {{number}}",
            available: "Disponible",
            unavailable: "No disponible",
            in_charge: "Cargando",
            next: "Siguiente",
            vehicle_plugged: "vehículo conectado",

            // Mensajes de procesamiento
            processing: {
                initializing: "Inicializando pago...",
                verifying: "Verificación en curso...",
                creatingPayment: "Creando método de pago...",
                setupPayment: "Configurando pago...",
                confirmingPayment: "Confirmando pago...",
                authorizing: "Autorizando...",
                startingCharge: "Iniciando carga..."
            },

            // Pago
            recapitulation: "Resumen de su sesión",
            Tarif: "Precio",
            pay: "Pagar",
            email: "Correo electrónico",
            enterEmail: "Ingrese su dirección de correo electrónico",
            securePayment: "Pago 100% seguro",
            pleaseWait: "Por favor espere ...",
            paymentPreparing: "Preparando el pago ...",
            plugBeforePayment:
                "Asegúrese de conectar su vehículo antes de iniciar la recarga.",
            emailLabel: "El correo electrónico es obligatorio",
            emailHelp: "Su correo electrónico es necesario para recibir el recibo.",
            cardNumber: "Número de tarjeta",
            ccv: "CCV*",
            exp: "EXP*",
            preAuthButton: "Preautorización (40 €)",
            preAuthNotice:
                "Es necesaria una <0>autorización previa de 40 €</0> a su tarjeta, pero solo se cobrará el importe exacto de su recarga. El saldo no usado se liberará en un plazo de 24 horas.",
            chargeLimitNotice: "Su recarga se detendrá si alcanza el importe de 40€.",
            missingPaymentId: "Datos faltantes: ID de pago no encontrado.",
            modalTitle: "¿Está su vehículo conectado?",
            cancel: "Cancelar",
            confirmationModalTitle: "Debe conectar su vehículo antes de iniciar la carga.",
            notYet: "Aún no está hecho",
            done: "Ya está hecho",
            yes: "Sí",
            no: "No",
            cardInformation: "Información de la tarjeta",
            payButton: "Pagar",
            paymentNotice: "Su información de pago es segura y no será almacenada.",

            // Infos
            preAuthValidated: "Preautorización validada",
            chargingWillStart: "Su recarga va a comenzar",
            startCharging: "Iniciar recarga",

            startCharging: {
                launching: "Iniciando la recarga ...",
                launched: "Carga iniciada",
                ended: "Recarga finalizada",
                ticket: {
                    download: "Descargar mi recibo",
                    preparing: "Preparando el recibo...",
                    errors: {
                        notAvailableYet: "Su justificante aún no está disponible. Inténtelo de nuevo en unos instantes.",
                        notFound: "No se ha encontrado ningún justificante para esta recarga.",
                        temporarilyUnavailable: "La descarga no está disponible temporalmente. Inténtelo más tarde."
                    }
                },
                chargingStation: "Estación de carga",
                connector: "Conector",
                transactionInfo: "Información de la transacción",
                status: "Estado",
                energy: "Energía consumida",
                duration: "Duración",
                chargeEnded: "Carga finalizada",
                chargeInProgress: "Cargando",
                stopCharge: "Detener carga",
                stoppingCharge: "Deteniendo...",
                confirmStopCharge: "Confirmar detención de carga",
                confirmStopChargeMessage: "¿Está seguro de que desea detener la carga? Esta acción no se puede deshacer.",
                unlockConnector: "Desbloquear el cable",
                unlocking: "Desbloqueando el cable...",
                confirmUnlock: "Confirmar desbloqueo",
                confirmUnlockMessage: "¿Está seguro de que desea desbloquear el cable?",
                cancel: "Cancelar",
                confirm: "Confirmar",
                errors: {
                    missingInfo: "Información faltante",
                    missingInfoMessage: "La información necesaria para iniciar una sesión de carga está faltando. Por favor, intente nuevamente desde el principio.",
                    missingStopInfo: "Información faltante para detener la carga",
                },
                apiError: "❌ Ocurrió un error. Por favor, inténtelo de nuevo.",
                unlock: {
                    sentTitle: "Solicitud enviada al punto de recarga",
                    sentText: "El cable se liberará en unos segundos. Retírelo del punto de recarga y luego de su vehículo.",
                    releasedTitle: "Cable retirado",
                    releasedText: "Puede cerrar esta página. Le hemos enviado su justificante por correo electrónico.",
                    stillLockedTitle: "¿El cable sigue bloqueado?",
                    stillLockedText: "Vuelva a intentar el desbloqueo. Si el cable sigue bloqueado, contacte con el servicio de atención al cliente indicando:",
                    retry: "Reintentar el desbloqueo",
                    stationLine: "Punto de recarga {{station}} · {{connector}}",
                    transactionLine: "Transacción n.º {{transaction}}",
                },
                connecting: {
                    title: "Conectando con el punto de recarga…",
                    text: "Estamos comprobando que el punto de recarga está listo para empezar. Solo tarda unos segundos.",
                    plugTitle: "Su vehículo debe estar conectado",
                    plugText: "Si aún no lo ha hecho, conecte el cable al punto de recarga y a su vehículo. Si la toma está detrás de una trampilla, se desbloquea ahora.",
                },
                startFailed: {
                    title: "La recarga no se inicia",
                    subtitle: "Contacte con el servicio de atención al cliente, le ayudamos a iniciarla.",
                    noCharge: "No se ha cobrado ningún importe.",
                    preauthRelease: "La preautorización de 40 € se anula automáticamente en un plazo máximo de 1 hora.",
                    checklistTitle: "Compruebe mientras tanto",
                    checkCable: "El cable está bien conectado en ambos extremos",
                    checkSchedule: "El vehículo no está bloqueado en carga programada",
                    retry: "Volver a intentar el inicio",
                },
                charging: {
                    status: "Cargando",
                    energyUnit: "kWh recargados",
                    duration: "Duración",
                    pricePerKwh: "Precio por kWh",
                    canCloseTitle: "Puede cerrar esta página",
                    followLink: "Siga la recarga con el enlace enviado a {{email}}",
                    followLinkNoEmail: "Siga la recarga con el enlace enviado por correo electrónico",
                    rescan: "O escanee de nuevo el punto de recarga e introduzca los 4 últimos dígitos de su tarjeta",
                    stop: "Detener la recarga",
                    stopping: "Deteniendo…",
                    confirmStopTitle: "¿Detener la recarga?",
                    confirmStopText: "Solo se cobrará la energía consumida. Después podrá desbloquear el cable.",
                    confirmStop: "Detener ahora",
                    cancel: "Seguir cargando",
                },
                completed: {
                    title: "Recarga finalizada",
                    amountDebited: "Importe cobrado",
                    amountPending: "Calculando",
                    energy: "Energía",
                    duration: "Duración",
                    released: "{{amount}} liberados automáticamente, el plazo depende de su banco",
                    receiptTitle: "Su justificante",
                    receiptSent: "Enviado a {{email}}. También puede descargarlo aquí.",
                    receiptSentNoEmail: "Enviado por correo electrónico. También puede descargarlo aquí.",
                    receiptPending: "Se enviará a {{email}} en cuanto esté disponible.",
                    receiptPendingNoEmail: "Se enviará por correo electrónico en cuanto esté disponible.",
                    download: "Descargar mi justificante",
                    preparing: "Descargando…",
                    unlock: "Desbloquear el cable",
                    confirmUnlockTitle: "¿Desbloquear el cable?",
                    confirmUnlockText: "El punto de recarga liberará el cable. Retírelo después del punto de recarga y de su vehículo.",
                    confirmUnlock: "Desbloquear",
                    amountPendingReleased: "El resto de los 40 € se liberará automáticamente, el plazo depende de su banco",
                    downloadFailed: "La descarga ha fallado. Su justificante sigue disponible en el correo recibido.",
                    retry: "Reintentar",
                    cancel: "Cancelar",
                },
            },
            landing: {
                title: "Recargue en 3 pasos",
                subtitle: "Sin cuenta ni aplicación.",
                step1Title: "Pague con tarjeta",
                step1Text: "Solo paga la energía consumida, a la tarifa indicada abajo.",
                step2Title: "Conecte su vehículo",
                step2Text: "¿Ya está conectado? Perfecto. Si la toma está detrás de una trampilla, se desbloquea tras la validación.",
                step3Title: "La recarga comienza",
                step3Text: "Automáticamente. La sigue desde esta página.",
                yourConnector: "Su toma",
                chooseConnector: "Elija su toma",
                continue: "Continuar",
            },
            emailStep: {
                title: "Su correo electrónico",
                subtitle: "Para enviarle el enlace de seguimiento de la recarga y su recibo.",
                label: "Correo electrónico",
                placeholder: "nombre@ejemplo.es",
                follow: "Siga su recarga",
                noAccount: "No se crea ninguna cuenta",
                invalid: "Introduzca un correo electrónico válido, por ejemplo nombre@ejemplo.es.",
                consent: "Acepto las <0>Condiciones Generales de Venta</0> y la <1>Política de privacidad</1>.",
            },
            payment: {
                title: "Pago con tarjeta",
                preauth: "<0>40 € bloqueados temporalmente</0>, <1>no cobrados</1>. Solo se cobrará el precio de su recarga.",
                howItWorks: "¿Cómo funciona?",
                yourCard: "Su tarjeta",
                secure: "Pago seguro",
                cardNumber: "Número de tarjeta",
                expiry: "Caducidad",
                cvc: "CVC",
                acceptedCards: "Se aceptan tarjetas francesas y extranjeras",
                submit: "Validar e iniciar",
                processing: "Verificando su tarjeta…",
                techError: "Se ha producido un error técnico y no se ha bloqueado ningún importe. Inténtelo de nuevo en unos instantes.",
            },
            howItWorks: {
                title: "Una preautorización, no un pago",
                subtitle: "Como en un surtidor de combustible, se reserva un importe durante la recarga.",
                startTitle: "Al inicio",
                startText: "Su banco reserva 40 €. No se cobra nada.",
                duringTitle: "Durante la recarga",
                duringText: "Se detiene sola al llegar a 40 €.",
                endTitle: "Al final",
                endText: "Solo se cobra el precio de la recarga. El resto se libera automáticamente, <0>en un plazo que depende de su banco</0>.",
                example: "Ejemplo",
                exampleCharged: "12 kWh recargados",
                exampleDebited: "{{amount}} cobrados",
                exampleReleased: "Liberado",
                gotIt: "Entendido",
            },
            refused: {
                title: "Su tarjeta ha sido rechazada",
                subtitle: "No se ha cobrado ningún importe.",
                generic: "Su banco no ha aceptado la preautorización de 40 €. Compruebe el límite de su tarjeta o que los pagos en línea estén activados.",
                insufficientFunds: "El saldo o el límite de su tarjeta no permite bloquear 40 €. Pruebe con otra tarjeta o contacte con su banco.",
                expiredCard: "Su tarjeta ha caducado. Pruebe con otra tarjeta.",
                incorrectCvc: "El código de seguridad (CVC) introducido es incorrecto. Compruebe los 3 dígitos del dorso de su tarjeta y vuelva a intentarlo.",
                authentication: "La validación con su banco (3D Secure) no se ha completado. Vuelva a intentarlo y confirme el pago en la aplicación de su banco.",
                tryAnother: "Probar con otra tarjeta",
                useApp: "Usar la aplicación Qovoltis",
                needHelp: "¿Necesita ayuda?",
            },
            invoice: {
                title: "Factura nominativa",
                intro: "Estos datos aparecerán en su factura, enviada a {{email}}.",
                introNoEmail: "Estos datos aparecerán en su factura, enviada por correo electrónico.",
                lastName: "Apellido",
                firstName: "Nombre",
                address: "Dirección",
                addressPlaceholder: "12 rue de la Paix, 75002 Paris",
                required: "* Campos obligatorios",
                fieldRequired: "Campo obligatorio",
                addressPick: "Elija una dirección de la lista.",
                save: "Guardar",
                noInvoice: "No deseo factura",
                noInvoiceTitle: "¿Continuar sin factura?",
                noInvoiceText: "Solo recibirá un recibo por correo electrónico. No podrá obtener una factura nominativa para esta recarga.",
                noInvoiceConfirm: "Sí, continuar sin factura",
                cancel: "Cancelar",
                needInvoice: "¿Necesita una factura nominativa?",
                addDetails: "Añadir mis datos",
                saved: "Sus datos aparecerán en su factura.",
                saveError: "No se han podido guardar sus datos.",
                savedDetail: "{{name}} · {{address}}",
                retry: "Reintentar",
            },
            language: {
                title: "Idioma",
                new: "Nuevo",
            },
            loadingStation: {
                title: "Cargando el punto de recarga…",
                text: "Estamos obteniendo las tomas y la tarifa.",
            },
            linkLoading: {
                title: "Cargando su recarga…",
                text: "Abriendo el enlace de seguimiento recibido por correo electrónico.",
            },
            ineligible: {
                title: "Este punto de recarga no acepta el pago con tarjeta",
                text: "Puede iniciarlo desde la aplicación Qovoltis en pocos minutos.",
            },
            errorPage: {
                text: "No se ha cobrado ningún importe. Inténtelo de nuevo o vuelva a escanear el código QR del punto de recarga.",
                retry: "Reintentar",
            },
            notFoundPage: {
                title: "Página no encontrada",
                text: "Esta dirección no corresponde a ningún punto de recarga. Vuelva a escanear el código QR del punto de recarga.",
            },
            linkInvalid: {
                text: "Para encontrar una recarga en curso, vuelva a escanear el punto de recarga e introduzca los 4 últimos dígitos de su tarjeta.",
            },
            resumeList: {
                subtitle: "Hay varias recargas en curso en este punto de recarga. Elija la toma a la que está conectado su vehículo.",
            },
            busy: {
                title: "Esta toma está ocupada",
                subtitle: "Hay una recarga en curso en este punto de recarga.",
                yoursTitle: "¿Es su recarga?",
                yoursText: "Sígala o deténgala desde su teléfono.",
                find: "Encontrar mi recarga",
                later: "Si no, vuelva a escanear el punto de recarga cuando la toma esté libre.",
            },
            intent: {
                title: "¿Qué desea hacer?",
                subtitle: "Ya hay una recarga en curso en este punto de recarga.",
                startTitle: "Iniciar una recarga",
                startText: "Hay una toma disponible",
                resumeTitle: "Reanudar mi recarga",
                resumeText: "Seguir o detener la recarga en curso",
            },
            common: {
                back: "Atrás",
                close: "Cerrar",
            },
            steps: {
                connector: "Toma",
                email: "Correo",
                payment: "Pago",
            },
            panel: {
                station: "Su punto de recarga",
                summary: "Resumen",
                charge: "Su recarga",
                address: "Dirección",
                connector: "Toma",
                rate: "Tarifa",
                preauth: "Preautorización",
                preauthValue: "40 € bloqueados, no cobrados",
                connectorsCount: "{{count}} tomas",
            },
            support: {
                whatsapp: "Escribir al servicio de atención al cliente",
                call: "Llamar al servicio de atención al cliente",
                orCall: "O llamar al servicio de atención al cliente",
                whatsappMessage: "Hola, necesito ayuda con mi recarga. Punto de recarga {{station}}, toma {{connector}}, {{time}}.",
                whatsappMessageTransaction: "Hola, necesito ayuda con mi recarga. Punto de recarga {{station}}, toma {{connector}}, transacción {{transaction}}, {{time}}.",
            },
            downloadApp: {
                title: "Gestiona tus recargas de forma más sencilla con nuestra aplicación móvil",
                description: "Sigue tus recargas, consulta tus facturas y encuentra fácilmente estaciones de carga cerca de ti, directamente desde tu smartphone.",
                downloadButton: "Descargar la aplicación",
                continueWithoutApp: "Continuar sin la aplicación",
                features: {
                    feature1: "Cargue con un clic",
                    feature2: "Siga su consumo",
                    feature3: "Encuentre todas las estaciones",
                    feature4: "Obtenga ofertas exclusivas"
                }
            },

            // Errores
            errorTitle: "¡Error!",
            genericErrorTitle: "Ha ocurrido un error",
            genericErrorMessage:
                "Error al crear su autorización. Por favor, inténtelo de nuevo.",
            errorIconAlt: "Icono de error",
            pageNotFound: "Página no encontrada o número de serie no válido",
            noBorneData: "Faltan datos de la estación de carga.",
            errors: {
                // Errores HTTP
                badRequest: "La solicitud es inválida. Por favor, verifique la información ingresada.",
                unauthorized: "No está autorizado para realizar esta acción. Por favor, inicie sesión de nuevo.",
                forbidden: "Acceso denegado. No tiene los permisos necesarios.",
                notFound: "El recurso solicitado no fue encontrado.",
                requestTimeout: "La solicitud ha expirado. Por favor, inténtelo de nuevo.",
                conflict: "Se ha detectado un conflicto. Por favor, actualice la página e inténtelo de nuevo.",
                validationError: "Los datos ingresados son inválidos. Por favor, verifique los campos.",
                tooManyRequests: "Demasiados intentos. Por favor, inténtelo más tarde.",
                serverError: "El servidor está experimentando un problema técnico. Por favor, inténtelo más tarde.",
                badGateway: "Ha ocurrido un problema de comunicación entre servidores. Por favor, inténtelo más tarde.",
                serviceUnavailable: "El servicio no está disponible temporalmente. Por favor, inténtelo más tarde.",
                gatewayTimeout: "El servidor tardó demasiado en responder. Por favor, inténtelo de nuevo.",

                // Errores Generales
                networkError: "Problema de conexión de red. Verifique su conexión a internet e inténtelo de nuevo.",
                unknownError: "Ha ocurrido un error inesperado. Por favor, inténtelo más tarde.",
                methodNotAllowed: "El método de solicitud no está permitido para este recurso.",
                invoiceError: "Ocurrió un error al enviar la factura. Por favor, inténtelo de nuevo.",
                chargingStationNotFound: "Estación de carga no encontrada",

                // Errores Específicos
                stripeError: "Ocurrió un error al procesar su pago. Por favor, verifique su información e inténtelo de nuevo.",
                recaptchaFailed: "La verificación de seguridad falló. Por favor, inténtelo de nuevo.",
                recaptchaExpired: "La verificación de seguridad ha expirado. Por favor, inténtelo de nuevo.",
                chargingFailed: "El inicio de la carga falló. Por favor, inténtelo de nuevo o contacte con soporte.",

                // Mensajes Existentes
                invalidResponse: "Error de red o respuesta no válida del servidor.",
                authorizationFailed: "Error al crear la autorización de pago.",
                paymentInitFailed: "No pudimos inicializar el pago seguro. Por favor, inténtelo de nuevo.",
                insufficientFunds: "No se puede usar esta tarjeta porque no tiene fondos suficientes. Por favor, intente con otra tarjeta.",
                errorAttachingPayment: "Ocurrió un error al guardar su método de pago. Por favor, inténtelo de nuevo.",
                cardDeclined: "Su tarjeta fue rechazada. Por favor, verifique su información o use otra tarjeta.",
                expiredCard: "Su tarjeta ha caducado. Por favor, use una tarjeta válida.",
                incorrectCvv: "El código de seguridad (CVV) es incorrecto. Por favor, verifique e inténtelo de nuevo.",
                processingError: "Ocurrió un error al procesar su solicitud. Por favor, inténtelo de nuevo.",
                emailRequired: "Por favor, introduzca su dirección de correo electrónico.",
                emailInvalid: "Por favor ingrese un correo electrónico válido",
                invalidEmail: "Por favor ingrese un correo electrónico válido.",
                apiError: "❌ Ha ocurrido un error. Inténtelo de nuevo.",


                stripeCustomerNotFound: "No pudimos encontrar su cliente Stripe y no pudimos crear uno nuevo",
                countryNotFound: "El país especificado no fue encontrado",
                postalCodeNotFound: "El código postal especificado no fue encontrado",
                noOngoingTransaction: "No se encontró ninguna transacción en curso para este usuario",
                transactionClosed: "Esta transacción ya ha sido cerrada",
                noAuthorizationFound: "No se encontró autorización de tarjeta de crédito para esta transacción",
                authorizationNotFound: "La autorización especificada no fue encontrada",
                authorizationNotFoundInDB: "La autorización especificada no fue encontrada en la base de datos",
                updatingAuthorizationError: "Ocurrió un error al actualizar la autorización",
                noDefaultCreditCard: "El usuario no tiene tarjeta de crédito predeterminada",
                evcpNotFound: "La estación de carga especificada no fue encontrada",
                connectorNotFound: "El conector especificado no fue encontrado en esta estación",
                useridTagNotFound: "Identificador de usuario no encontrado",
                failedAssociateUser: "Error al asociar usuario",
                internalError: "Error interno. Por favor inténtelo de nuevo",
                noOngoingCpSession: "No hay sesión de carga en curso para este usuario. Verifique si la estación está en línea y si su sesión es válida",
                remoteStartDenied: "Inicio remoto denegado",
                kafkaError: "Error inesperado al enviar a Kafka",
                transactionNotAssociated: "La transacción no está asociada con la estación especificada",
                cpDisconnected: "La estación de carga está desconectada",

            },
            access_denied_no_session: "Acceso denegado: no se encontró ninguna sesión de carga.",
            notEligibleForOneClick: "Esta estación no es elegible para Scan to Charge. Por favor descargue nuestra aplicación para continuar.",
            storeRedirect: {
                downloadTitle: "Descargue nuestra aplicación",
                downloadDescription: "Para una mejor experiencia, descargue la aplicación Qovoltis."
            },
            sessionChoice: {
                title: "Hay una recarga en curso en esta estación",
                question: "¿Qué desea hacer?",
                startNew: {
                    title: "Iniciar una nueva recarga",
                    description: "Elija un conector disponible y conecte su vehículo.",
                    noConnectorAvailable: "No hay ningún conector disponible en esta estación por el momento."
                },
                resume: {
                    title: "Reanudar mi recarga en curso",
                    description: "Consulte o detenga la recarga que ya ha iniciado."
                }
            },
            resumeSession: {
                findTitle: "Encontrar mi recarga",
                findSubtitle: "Introduzca los 4 últimos dígitos de la tarjeta utilizada para pagar.",
                emailLinkHint: "También puede usar el enlace de seguimiento recibido por correo electrónico.",
                access: "Acceder a mi recarga",
                digitLabel: "Dígito {{position}} de 4",
                title: "Reanudar sesión",
                sessionActive: "Hay una recarga en curso en este conector.",
                cta: "Reanudar mi sesión",
                cardLabel: "Introduzca los últimos 4 dígitos de la tarjeta utilizada",
                validate: "Validar",
                verifying: "Verificando...",
                errors: {
                    invalidFormat: "Introduzca los últimos 4 dígitos de su tarjeta.",
                    wrongCard: "Código incorrecto. Le quedan {{count}} intento(s).",
                    tooManyAttempts: "Demasiados intentos. Inténtelo de nuevo más tarde.",
                    wrongDigits: "Estos dígitos no corresponden a la recarga en curso. Compruebe la tarjeta utilizada.",
                    missingInfo: "Falta información de la sesión.",
                    invalidLink: "Este enlace no es válido o ha caducado.",
                    generic: "Se ha producido un error. Inténtelo de nuevo."
                }
            },
            chargingStarted: "Carga iniciada con éxito",
            chargingStationInfo: "Información de la estación de carga",
            connectorInfo: "Información del conector"
        }
    },
    de: {
        translation: {
            loading: "Wird geladen",
            address: "Adresse der Ladestation",
            choose_connector: "Wählen Sie einen Anschluss",
            choose_connector_resume: "Welchen Ladevorgang möchten Sie fortsetzen?",
            your_connector: "Ihr Anschluss",
            connector: "Anschluss {{number}}",
            available: "Verfügbar",
            unavailable: "Nicht verfügbar",
            in_charge: "Lädt",
            next: "Weiter",
            vehicle_plugged: "Fahrzeug angeschlossen",
            processing: {
                initializing: "Zahlung wird vorbereitet...",
                verifying: "Überprüfung läuft...",
                creatingPayment: "Zahlungsmittel wird erstellt...",
                setupPayment: "Zahlung wird eingerichtet...",
                confirmingPayment: "Zahlung wird bestätigt...",
                authorizing: "Autorisierung läuft...",
                startingCharge: "Ladevorgang wird gestartet...",
            },
            recapitulation: "Zusammenfassung Ihres Ladevorgangs",
            Tarif: "Tarif",
            pay: "Bezahlen",
            email: "E-Mail-Adresse",
            enterEmail: "Geben Sie Ihre E-Mail-Adresse ein",
            securePayment: "100 % sichere Zahlung",
            pleaseWait: "Bitte warten ...",
            paymentPreparing: "Zahlung wird vorbereitet ...",
            plugBeforePayment: "Schließen Sie Ihr Fahrzeug an, bevor Sie den Ladevorgang starten.",
            emailLabel: "E-Mail-Adresse*",
            emailHelp: "Ihre E-Mail-Adresse wird für den Beleg benötigt.",
            cardNumber: "Kartennummer*",
            ccv: "CVC*",
            exp: "Ablaufdatum*",
            preAuthButton: "Vorautorisierung (40 €)",
            preAuthNotice: "Eine <0>Vorautorisierung von 40 €</0> wird vorgenommen, abgebucht wird jedoch nur der genaue Betrag Ihres Ladevorgangs. Der nicht genutzte Betrag wird automatisch innerhalb von 24 Stunden freigegeben.",
            chargeLimitNotice: "Ihr Ladevorgang endet, sobald er den Betrag von 40 € erreicht.",
            missingPaymentId: "Fehlende Daten: Zahlungs-ID nicht gefunden.",
            modalTitle: "Ist Ihr Fahrzeug angeschlossen?",
            cancel: "Abbrechen",
            confirmationModalTitle: "Sie müssen Ihr Fahrzeug anschließen, bevor Sie den Ladevorgang starten.",
            notYet: "Noch nicht",
            done: "Erledigt",
            yes: "Ja",
            no: "Nein",
            cardInformation: "Karteninformationen",
            payButton: "Bezahlen",
            paymentNotice: "Ihre Zahlungsdaten sind geschützt und werden nicht gespeichert.",
            preAuthValidated: "Vorautorisierung bestätigt",
            chargingWillStart: "Ihr Ladevorgang beginnt gleich",
            startCharging: {
                launching: "Ladevorgang wird gestartet ...",
                launched: "Ladevorgang gestartet",
                ended: "Ladevorgang beendet",
                ticket: {
                    download: "Meinen Beleg herunterladen",
                    preparing: "Beleg wird vorbereitet...",
                    errors: {
                        notAvailableYet: "Ihr Beleg ist noch nicht verfügbar. Versuchen Sie es in wenigen Augenblicken erneut.",
                        notFound: "Für diesen Ladevorgang wurde kein Beleg gefunden.",
                        temporarilyUnavailable: "Der Download ist vorübergehend nicht verfügbar. Versuchen Sie es später erneut.",
                    },
                },
                chargingStation: "Ladestation",
                connector: "Anschluss",
                transactionInfo: "Informationen zum Ladevorgang",
                status: "Status",
                energy: "Verbrauchte Energie",
                duration: "Dauer",
                chargeEnded: "Ladevorgang beendet",
                chargeInProgress: "Lädt",
                stopCharge: "Ladevorgang beenden",
                stoppingCharge: "Wird beendet...",
                confirmStopCharge: "Beenden des Ladevorgangs bestätigen",
                confirmStopChargeMessage: "Möchten Sie den Ladevorgang wirklich beenden? Diese Aktion kann nicht rückgängig gemacht werden.",
                unlockConnector: "Kabel entriegeln",
                unlocking: "Kabel wird entriegelt...",
                confirmUnlock: "Entriegeln bestätigen",
                confirmUnlockMessage: "Möchten Sie das Kabel wirklich entriegeln?",
                cancel: "Abbrechen",
                confirm: "Bestätigen",
                errors: {
                    missingInfo: "Fehlende Informationen",
                    missingInfoMessage: "Die zum Starten eines Ladevorgangs nötigen Informationen fehlen. Bitte beginnen Sie von vorne.",
                    missingStopInfo: "Fehlende Informationen zum Beenden des Ladevorgangs",
                },
                apiError: "❌ Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
                unlock: {
                    sentTitle: "Anfrage an die Ladestation gesendet",
                    sentText: "Das Kabel wird in wenigen Sekunden freigegeben. Ziehen Sie es zuerst aus der Ladestation und dann aus Ihrem Fahrzeug.",
                    releasedTitle: "Kabel abgezogen",
                    releasedText: "Sie können diese Seite schließen. Ihr Beleg wurde Ihnen per E-Mail gesendet.",
                    stillLockedTitle: "Ist das Kabel noch verriegelt?",
                    stillLockedText: "Versuchen Sie erneut, es zu entriegeln. Bleibt das Kabel verriegelt, kontaktieren Sie den Kundenservice mit folgenden Angaben:",
                    retry: "Entriegeln erneut versuchen",
                    stationLine: "Ladestation {{station}} · {{connector}}",
                    transactionLine: "Transaktion Nr. {{transaction}}",
                },
                connecting: {
                    title: "Verbindung zur Ladestation…",
                    text: "Wir prüfen, ob die Ladestation startbereit ist. Das dauert nur wenige Sekunden.",
                    plugTitle: "Ihr Fahrzeug muss angeschlossen sein",
                    plugText: "Falls noch nicht geschehen, verbinden Sie das Kabel mit der Ladestation und Ihrem Fahrzeug. Befindet sich der Anschluss hinter einer Klappe, wird sie jetzt entriegelt.",
                },
                startFailed: {
                    title: "Der Ladevorgang startet nicht",
                    subtitle: "Kontaktieren Sie den Kundenservice, wir helfen Ihnen beim Starten.",
                    noCharge: "Es wurde nichts abgebucht.",
                    preauthRelease: "Die Vorautorisierung von 40 € wird spätestens nach 1 Stunde automatisch storniert.",
                    checklistTitle: "Bitte prüfen Sie in der Zwischenzeit",
                    checkCable: "Das Kabel ist an beiden Enden fest eingesteckt",
                    checkSchedule: "Das Fahrzeug ist nicht auf zeitgesteuertes Laden eingestellt",
                    retry: "Start erneut versuchen",
                },
                charging: {
                    status: "Lädt",
                    energyUnit: "kWh geladen",
                    duration: "Dauer",
                    pricePerKwh: "Preis pro kWh",
                    canCloseTitle: "Sie können diese Seite schließen",
                    followLink: "Verfolgen Sie den Ladevorgang über den Link, der an {{email}} gesendet wurde",
                    followLinkNoEmail: "Verfolgen Sie den Ladevorgang über den Link, den Sie per E-Mail erhalten haben",
                    rescan: "Oder scannen Sie die Ladestation erneut und geben Sie die letzten 4 Ziffern Ihrer Karte ein",
                    stop: "Ladevorgang beenden",
                    stopping: "Wird beendet…",
                    confirmStopTitle: "Ladevorgang beenden?",
                    confirmStopText: "Abgebucht wird nur die verbrauchte Energie. Anschließend können Sie das Kabel entriegeln.",
                    confirmStop: "Jetzt beenden",
                    cancel: "Weiterladen",
                },
                completed: {
                    title: "Ladevorgang beendet",
                    amountDebited: "Abgebuchter Betrag",
                    amountPending: "Wird berechnet",
                    energy: "Energie",
                    duration: "Dauer",
                    released: "{{amount}} automatisch freigegeben, Dauer abhängig von Ihrer Bank",
                    receiptTitle: "Ihr Beleg",
                    receiptSent: "An {{email}} gesendet. Sie können ihn auch hier herunterladen.",
                    receiptSentNoEmail: "Per E-Mail gesendet. Sie können ihn auch hier herunterladen.",
                    receiptPending: "Er wird an {{email}} gesendet, sobald er verfügbar ist.",
                    receiptPendingNoEmail: "Er wird per E-Mail gesendet, sobald er verfügbar ist.",
                    download: "Meinen Beleg herunterladen",
                    preparing: "Download läuft…",
                    unlock: "Kabel entriegeln",
                    confirmUnlockTitle: "Kabel entriegeln?",
                    confirmUnlockText: "Die Ladestation gibt das Kabel frei. Ziehen Sie es anschließend zuerst aus der Ladestation und dann aus Ihrem Fahrzeug.",
                    confirmUnlock: "Entriegeln",
                    cancel: "Abbrechen",
                    amountPendingReleased: "Der Rest der 40 € wird automatisch freigegeben, Dauer abhängig von Ihrer Bank",
                    downloadFailed: "Der Download ist fehlgeschlagen. Ihr Beleg ist weiterhin in der erhaltenen E-Mail verfügbar.",
                    retry: "Erneut versuchen",
                },
            },
            landing: {
                title: "In 3 Schritten laden",
                subtitle: "Ohne Konto und ohne App.",
                step1Title: "Mit Karte bezahlen",
                step1Text: "Sie zahlen nur die verbrauchte Energie, zum unten angezeigten Tarif.",
                step2Title: "Fahrzeug anschließen",
                step2Text: "Schon angeschlossen? Perfekt. Befindet sich der Anschluss hinter einer Klappe, wird sie nach der Bestätigung entriegelt.",
                step3Title: "Der Ladevorgang startet",
                step3Text: "Automatisch. Sie verfolgen ihn auf dieser Seite.",
                yourConnector: "Ihr Anschluss",
                chooseConnector: "Wählen Sie Ihren Anschluss",
                continue: "Weiter",
            },
            emailStep: {
                title: "Ihre E-Mail-Adresse",
                subtitle: "Damit wir Ihnen den Link zum Verfolgen des Ladevorgangs und Ihren Beleg senden können.",
                label: "E-Mail-Adresse",
                placeholder: "name@beispiel.de",
                follow: "Ladevorgang verfolgen",
                noAccount: "Es wird kein Konto erstellt",
                consent: "Ich akzeptiere die <0>Allgemeinen Verkaufsbedingungen</0> und die <1>Datenschutzerklärung</1>.",
                invalid: "Geben Sie eine gültige E-Mail-Adresse ein, zum Beispiel name@beispiel.de.",
            },
            payment: {
                title: "Zahlung mit Karte",
                preauth: "<0>40 € vorübergehend</0> reserviert, <1>nicht abgebucht</1>. Abgebucht wird nur der Preis Ihres Ladevorgangs.",
                howItWorks: "Wie funktioniert das?",
                yourCard: "Ihre Karte",
                secure: "Sichere Zahlung",
                cardNumber: "Kartennummer",
                expiry: "Ablaufdatum",
                cvc: "CVC",
                acceptedCards: "Französische und ausländische Karten werden akzeptiert",
                submit: "Bestätigen und starten",
                processing: "Ihre Karte wird geprüft…",
                techError: "Ein technischer Fehler ist aufgetreten, es wurde kein Betrag reserviert. Versuchen Sie es in wenigen Augenblicken erneut.",
            },
            howItWorks: {
                title: "Eine Vorautorisierung, keine Zahlung",
                subtitle: "Wie an einer Zapfsäule wird für die Dauer des Ladevorgangs ein Betrag reserviert.",
                startTitle: "Beim Start",
                startText: "Ihre Bank reserviert 40 €. Es wird nichts abgebucht.",
                duringTitle: "Während des Ladens",
                duringText: "Der Ladevorgang endet automatisch bei 40 €.",
                endTitle: "Am Ende",
                endText: "Abgebucht wird nur der Preis des Ladevorgangs. Der Rest wird automatisch freigegeben, <0>innerhalb einer Frist, die von Ihrer Bank abhängt</0>.",
                example: "Beispiel",
                exampleCharged: "12 kWh geladen",
                exampleDebited: "{{amount}} abgebucht",
                exampleReleased: "Freigegeben",
                gotIt: "Verstanden",
            },
            refused: {
                title: "Ihre Karte wurde abgelehnt",
                subtitle: "Es wurde nichts abgebucht.",
                generic: "Ihre Bank hat die Vorautorisierung von 40 € nicht akzeptiert. Prüfen Sie das Limit Ihrer Karte oder ob Online-Zahlungen aktiviert sind.",
                insufficientFunds: "Das Guthaben oder Limit Ihrer Karte reicht nicht aus, um 40 € zu reservieren. Versuchen Sie es mit einer anderen Karte oder wenden Sie sich an Ihre Bank.",
                expiredCard: "Ihre Karte ist abgelaufen. Versuchen Sie es mit einer anderen Karte.",
                incorrectCvc: "Der eingegebene Sicherheitscode (CVC) ist falsch. Prüfen Sie die 3 Ziffern auf der Rückseite Ihrer Karte und versuchen Sie es erneut.",
                authentication: "Die Bestätigung bei Ihrer Bank (3D Secure) wurde nicht abgeschlossen. Versuchen Sie es erneut und bestätigen Sie die Zahlung in der App Ihrer Bank.",
                tryAnother: "Andere Karte verwenden",
                useApp: "Qovoltis-App verwenden",
                needHelp: "Brauchen Sie Hilfe?",
            },
            invoice: {
                title: "Rechnung auf Ihren Namen",
                intro: "Diese Angaben erscheinen auf Ihrer Rechnung, die an {{email}} gesendet wird.",
                introNoEmail: "Diese Angaben erscheinen auf Ihrer Rechnung, die per E-Mail gesendet wird.",
                lastName: "Nachname",
                firstName: "Vorname",
                address: "Adresse",
                addressPlaceholder: "12 rue de la Paix, 75002 Paris",
                required: "* Pflichtfelder",
                fieldRequired: "Pflichtfeld",
                addressPick: "Wählen Sie eine Adresse aus der Liste.",
                save: "Speichern",
                noInvoice: "Ich möchte keine Rechnung",
                noInvoiceTitle: "Ohne Rechnung fortfahren?",
                noInvoiceText: "Sie erhalten nur einen Beleg per E-Mail. Eine Rechnung auf Ihren Namen ist für diesen Ladevorgang dann nicht mehr möglich.",
                noInvoiceConfirm: "Ja, ohne Rechnung fortfahren",
                cancel: "Abbrechen",
                needInvoice: "Benötigen Sie eine Rechnung auf Ihren Namen?",
                addDetails: "Meine Angaben hinzufügen",
                saved: "Ihre Angaben erscheinen auf Ihrer Rechnung.",
                saveError: "Ihre Angaben konnten nicht gespeichert werden.",
                savedDetail: "{{name}} · {{address}}",
                retry: "Erneut versuchen",
            },
            language: {
                title: "Sprache",
                new: "Neu",
            },
            loadingStation: {
                title: "Ladestation wird geladen…",
                text: "Wir rufen die Anschlüsse und den Tarif ab.",
            },
            linkLoading: {
                title: "Ihr Ladevorgang wird geladen…",
                text: "Der Link zum Verfolgen aus Ihrer E-Mail wird geöffnet.",
            },
            ineligible: {
                title: "Diese Ladestation akzeptiert keine Kartenzahlung",
                text: "Sie können sie in wenigen Minuten über die Qovoltis-App starten.",
            },
            errorPage: {
                text: "Es wurde kein Betrag abgebucht. Versuchen Sie es erneut oder scannen Sie den QR-Code der Ladestation erneut.",
                retry: "Erneut versuchen",
            },
            notFoundPage: {
                title: "Seite nicht gefunden",
                text: "Diese Adresse gehört zu keiner Ladestation. Scannen Sie den QR-Code an der Ladestation erneut.",
            },
            linkInvalid: {
                text: "Um einen laufenden Ladevorgang wiederzufinden, scannen Sie die Ladestation erneut und geben Sie die letzten 4 Ziffern Ihrer Karte ein.",
            },
            resumeList: {
                subtitle: "An dieser Ladestation laufen mehrere Ladevorgänge. Wählen Sie den Anschluss, an dem Ihr Fahrzeug angeschlossen ist.",
            },
            busy: {
                title: "Dieser Anschluss ist belegt",
                subtitle: "An dieser Ladestation läuft ein Ladevorgang.",
                yoursTitle: "Ist das Ihr Ladevorgang?",
                yoursText: "Verfolgen oder beenden Sie ihn auf Ihrem Telefon.",
                find: "Meinen Ladevorgang finden",
                later: "Andernfalls scannen Sie die Ladestation erneut, sobald der Anschluss frei ist.",
            },
            intent: {
                title: "Was möchten Sie tun?",
                subtitle: "An dieser Ladestation läuft bereits ein Ladevorgang.",
                startTitle: "Ladevorgang starten",
                startText: "Ein Anschluss ist verfügbar",
                resumeTitle: "Meinen Ladevorgang fortsetzen",
                resumeText: "Laufenden Ladevorgang verfolgen oder beenden",
            },
            common: {
                back: "Zurück",
                close: "Schließen",
            },
            steps: {
                connector: "Anschluss",
                email: "E-Mail",
                payment: "Zahlung",
            },
            panel: {
                station: "Ihre Ladestation",
                summary: "Zusammenfassung",
                charge: "Ihr Ladevorgang",
                address: "Adresse",
                connector: "Anschluss",
                rate: "Tarif",
                preauth: "Vorautorisierung",
                preauthValue: "40 € reserviert, nicht abgebucht",
                connectorsCount: "{{count}} Anschlüsse",
            },
            support: {
                whatsapp: "Kundenservice anschreiben",
                call: "Kundenservice anrufen",
                orCall: "Oder Kundenservice anrufen",
                whatsappMessage: "Hallo, ich brauche Hilfe bei meinem Ladevorgang. Ladestation {{station}}, Anschluss {{connector}}, {{time}}.",
                whatsappMessageTransaction: "Hallo, ich brauche Hilfe bei meinem Ladevorgang. Ladestation {{station}}, Anschluss {{connector}}, Ladevorgang {{transaction}}, {{time}}.",
            },
            downloadApp: {
                title: "Verwalten Sie Ihre Ladevorgänge einfacher mit unserer App",
                description: "Verfolgen Sie Ihre Ladevorgänge, sehen Sie Ihre Rechnungen ein und finden Sie Ladestationen in Ihrer Nähe, direkt auf Ihrem Smartphone.",
                downloadButton: "App herunterladen",
                continueWithoutApp: "Ohne App fortfahren",
                features: {
                    feature1: "Mit einem Klick laden",
                    feature2: "Ihren Verbrauch verfolgen",
                    feature3: "Alle Ladestationen finden",
                    feature4: "Exklusive Angebote nutzen",
                },
            },
            errorTitle: "Fehler!",
            genericErrorTitle: "Ein Fehler ist aufgetreten",
            genericErrorMessage: "Fehler beim Erstellen Ihrer Autorisierung. Bitte versuchen Sie es erneut.",
            errorIconAlt: "Fehlersymbol",
            pageNotFound: "Seite nicht gefunden oder ungültige Seriennummer",
            noBorneData: "Daten der Ladestation fehlen.",
            errors: {
                badRequest: "Die Anfrage ist ungültig. Bitte prüfen Sie Ihre Eingaben.",
                unauthorized: "Sie sind nicht berechtigt, diese Aktion auszuführen. Bitte melden Sie sich erneut an.",
                forbidden: "Zugriff verweigert. Sie haben nicht die nötigen Berechtigungen.",
                notFound: "Die angeforderte Ressource wurde nicht gefunden.",
                requestTimeout: "Die Anfrage ist abgelaufen. Bitte versuchen Sie es erneut.",
                conflict: "Ein Konflikt wurde festgestellt. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
                validationError: "Die eingegebenen Daten sind ungültig. Bitte prüfen Sie die Felder.",
                tooManyRequests: "Zu viele Versuche. Bitte versuchen Sie es später erneut.",
                serverError: "Der Server hat ein technisches Problem. Bitte versuchen Sie es später erneut.",
                badGateway: "Bei der Kommunikation zwischen den Servern ist ein Problem aufgetreten. Bitte versuchen Sie es später erneut.",
                serviceUnavailable: "Der Dienst ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
                gatewayTimeout: "Der Server hat zu lange nicht geantwortet. Bitte versuchen Sie es später erneut.",
                networkError: "Netzwerkproblem. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
                unknownError: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
                methodNotAllowed: "Die Anfragemethode ist für diese Ressource nicht zulässig.",
                invoiceError: "Beim Versenden der Rechnung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                chargingStationNotFound: "Ladestation nicht gefunden",
                stripeError: "Bei der Verarbeitung Ihrer Zahlung ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre Angaben und versuchen Sie es erneut.",
                recaptchaFailed: "Die Sicherheitsprüfung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
                recaptchaExpired: "Die Sicherheitsprüfung ist abgelaufen. Bitte versuchen Sie es erneut.",
                chargingFailed: "Der Start des Ladevorgangs ist fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
                invalidResponse: "Netzwerkfehler oder ungültige Antwort des Servers.",
                authorizationFailed: "Die Zahlungsautorisierung konnte nicht erstellt werden.",
                paymentInitFailed: "Die sichere Zahlung konnte nicht vorbereitet werden. Bitte versuchen Sie es erneut.",
                insufficientFunds: "Diese Karte kann wegen unzureichender Deckung nicht verwendet werden. Bitte versuchen Sie es mit einer anderen Karte.",
                errorAttachingPayment: "Beim Speichern Ihres Zahlungsmittels ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                cardDeclined: "Ihre Karte wurde abgelehnt. Bitte prüfen Sie Ihre Angaben oder verwenden Sie eine andere Karte.",
                expiredCard: "Ihre Karte ist abgelaufen. Bitte verwenden Sie eine gültige Karte.",
                incorrectCvv: "Der Sicherheitscode (CVV) ist falsch. Bitte prüfen Sie ihn und versuchen Sie es erneut.",
                processingError: "Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
                emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
                invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                apiError: "❌ Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
                stripeCustomerNotFound: "Ihr Stripe-Kunde wurde nicht gefunden und konnte nicht neu angelegt werden",
                countryNotFound: "Das angegebene Land wurde nicht gefunden",
                postalCodeNotFound: "Die angegebene Postleitzahl wurde nicht gefunden",
                noOngoingTransaction: "Für diesen Nutzer wurde kein laufender Ladevorgang gefunden",
                transactionClosed: "Dieser Ladevorgang wurde bereits abgeschlossen",
                noAuthorizationFound: "Für diesen Ladevorgang wurde keine Kreditkartenautorisierung gefunden",
                authorizationNotFound: "Die angegebene Autorisierung wurde nicht gefunden",
                authorizationNotFoundInDB: "Die angegebene Autorisierung wurde in der Datenbank nicht gefunden",
                updatingAuthorizationError: "Beim Aktualisieren der Autorisierung ist ein Fehler aufgetreten",
                noDefaultCreditCard: "Der Nutzer hat keine Standard-Kreditkarte",
                evcpNotFound: "Die angegebene Ladestation wurde nicht gefunden",
                connectorNotFound: "Der angegebene Anschluss wurde an dieser Ladestation nicht gefunden",
                useridTagNotFound: "Nutzerkennung nicht gefunden",
                failedAssociateUser: "Der Nutzer konnte nicht zugeordnet werden",
                internalError: "Interner Fehler. Bitte versuchen Sie es erneut",
                noOngoingCpSession: "Für diesen Nutzer läuft kein Ladevorgang. Prüfen Sie, ob die Ladestation online und Ihre Sitzung gültig ist",
                remoteStartDenied: "Fernstart abgelehnt",
                kafkaError: "Unerwarteter Fehler beim Senden an Kafka",
                transactionNotAssociated: "Der Ladevorgang gehört nicht zur angegebenen Ladestation",
                cpDisconnected: "Die Ladestation ist nicht verbunden",
            },
            access_denied_no_session: "Zugriff verweigert: kein Ladevorgang gefunden.",
            notEligibleForOneClick: "Diese Ladestation unterstützt Scan to Charge nicht. Bitte laden Sie unsere App herunter, um fortzufahren.",
            storeRedirect: {
                downloadTitle: "Laden Sie unsere App herunter",
                downloadDescription: "Für ein besseres Erlebnis laden Sie die Qovoltis-App herunter.",
            },
            sessionChoice: {
                title: "An dieser Ladestation läuft ein Ladevorgang",
                question: "Was möchten Sie tun?",
                startNew: {
                    title: "Neuen Ladevorgang starten",
                    description: "Wählen Sie einen verfügbaren Anschluss und schließen Sie Ihr Fahrzeug an.",
                    noConnectorAvailable: "An dieser Ladestation ist derzeit kein Anschluss verfügbar.",
                },
                resume: {
                    title: "Meinen laufenden Ladevorgang fortsetzen",
                    description: "Verfolgen oder beenden Sie den Ladevorgang, den Sie bereits gestartet haben.",
                },
            },
            resumeSession: {
                findTitle: "Meinen Ladevorgang finden",
                findSubtitle: "Geben Sie die letzten 4 Ziffern der Karte ein, mit der Sie bezahlt haben.",
                emailLinkHint: "Sie können auch den Link aus der E-Mail verwenden.",
                access: "Zu meinem Ladevorgang",
                digitLabel: "Ziffer {{position}} von 4",
                title: "Ladevorgang fortsetzen",
                sessionActive: "An diesem Anschluss läuft ein Ladevorgang.",
                cta: "Meinen Ladevorgang fortsetzen",
                cardLabel: "Geben Sie die letzten 4 Ziffern der verwendeten Karte ein",
                validate: "Bestätigen",
                verifying: "Wird überprüft...",
                errors: {
                    invalidFormat: "Bitte geben Sie die letzten 4 Ziffern Ihrer Karte ein.",
                    wrongCard: "Falscher Code. Sie haben noch {{count}} Versuch(e).",
                    tooManyAttempts: "Zu viele Versuche. Bitte versuchen Sie es später erneut.",
                    wrongDigits: "Diese Ziffern passen nicht zum laufenden Ladevorgang. Prüfen Sie die verwendete Karte.",
                    missingInfo: "Sitzungsinformationen fehlen.",
                    invalidLink: "Dieser Link ist ungültig oder abgelaufen.",
                    generic: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
                },
            },
            chargingStarted: "Ladevorgang erfolgreich gestartet",
            chargingStationInfo: "Informationen zur Ladestation",
            connectorInfo: "Informationen zum Anschluss",
        }
    },
    nl: {
        translation: {
            loading: "Laden",
            address: "Adres van de laadpaal",
            choose_connector: "Kies een aansluiting",
            choose_connector_resume: "Welke laadsessie wilt u hervatten?",
            your_connector: "Uw aansluiting",
            connector: "Aansluiting {{number}}",
            available: "Beschikbaar",
            unavailable: "Niet beschikbaar",
            in_charge: "Aan het laden",
            next: "Volgende",
            vehicle_plugged: "voertuig aangesloten",
            processing: {
                initializing: "Betaling wordt voorbereid...",
                verifying: "Bezig met controleren...",
                creatingPayment: "Betaalmiddel wordt aangemaakt...",
                setupPayment: "Betaling wordt ingesteld...",
                confirmingPayment: "Betaling wordt bevestigd...",
                authorizing: "Bezig met autoriseren...",
                startingCharge: "Laadsessie wordt gestart...",
            },
            recapitulation: "Overzicht van uw laadsessie",
            Tarif: "Tarief",
            pay: "Betalen",
            email: "E-mailadres",
            enterEmail: "Vul uw e-mailadres in",
            securePayment: "100% veilige betaling",
            pleaseWait: "Even geduld ...",
            paymentPreparing: "Betaling wordt voorbereid ...",
            plugBeforePayment: "Sluit uw voertuig aan voordat u de laadsessie start.",
            emailLabel: "E-mailadres*",
            emailHelp: "Uw e-mailadres is nodig om het betaalbewijs te ontvangen.",
            cardNumber: "Kaartnummer*",
            ccv: "CVC*",
            exp: "Vervaldatum*",
            preAuthButton: "Pre-autorisatie (€ 40)",
            preAuthNotice: "Er wordt een <0>pre-autorisatie van € 40</0> uitgevoerd, maar alleen het exacte bedrag van uw laadsessie wordt afgeschreven. Het niet gebruikte saldo wordt binnen 24 uur automatisch vrijgegeven.",
            chargeLimitNotice: "Uw laadsessie stopt zodra het bedrag van € 40 is bereikt.",
            missingPaymentId: "Ontbrekende gegevens: betalings-ID niet gevonden.",
            modalTitle: "Is uw voertuig aangesloten?",
            cancel: "Annuleren",
            confirmationModalTitle: "U moet uw voertuig aansluiten voordat u de laadsessie start.",
            notYet: "Nog niet",
            done: "Gedaan",
            yes: "Ja",
            no: "Nee",
            cardInformation: "Kaartgegevens",
            payButton: "Betalen",
            paymentNotice: "Uw betaalgegevens zijn beveiligd en worden niet opgeslagen.",
            preAuthValidated: "Pre-autorisatie bevestigd",
            chargingWillStart: "Uw laadsessie begint zo",
            startCharging: {
                launching: "Laadsessie wordt gestart ...",
                launched: "Laadsessie gestart",
                ended: "Laadsessie beëindigd",
                ticket: {
                    download: "Mijn betaalbewijs downloaden",
                    preparing: "Betaalbewijs wordt voorbereid...",
                    errors: {
                        notAvailableYet: "Uw betaalbewijs is nog niet beschikbaar. Probeer het over enkele ogenblikken opnieuw.",
                        notFound: "Er is geen betaalbewijs gevonden voor deze laadsessie.",
                        temporarilyUnavailable: "Downloaden is tijdelijk niet mogelijk. Probeer het later opnieuw.",
                    },
                },
                chargingStation: "Laadpaal",
                connector: "Aansluiting",
                transactionInfo: "Gegevens van de laadsessie",
                status: "Status",
                energy: "Verbruikte energie",
                duration: "Duur",
                chargeEnded: "Laadsessie beëindigd",
                chargeInProgress: "Aan het laden",
                stopCharge: "Laadsessie stoppen",
                stoppingCharge: "Bezig met stoppen...",
                confirmStopCharge: "Stoppen van de laadsessie bevestigen",
                confirmStopChargeMessage: "Weet u zeker dat u de laadsessie wilt stoppen? Deze actie kan niet ongedaan worden gemaakt.",
                unlockConnector: "Kabel ontgrendelen",
                unlocking: "Kabel wordt ontgrendeld...",
                confirmUnlock: "Ontgrendelen bevestigen",
                confirmUnlockMessage: "Weet u zeker dat u de kabel wilt ontgrendelen?",
                cancel: "Annuleren",
                confirm: "Bevestigen",
                errors: {
                    missingInfo: "Ontbrekende gegevens",
                    missingInfoMessage: "De gegevens die nodig zijn om een laadsessie te starten ontbreken. Begin opnieuw.",
                    missingStopInfo: "Ontbrekende gegevens om de laadsessie te stoppen",
                },
                apiError: "❌ Er is een fout opgetreden. Probeer het opnieuw.",
                unlock: {
                    sentTitle: "Verzoek naar de laadpaal verzonden",
                    sentText: "De kabel wordt binnen enkele seconden vrijgegeven. Haal hem eerst uit de laadpaal en daarna uit uw voertuig.",
                    releasedTitle: "Kabel losgekoppeld",
                    releasedText: "U kunt deze pagina sluiten. Uw betaalbewijs is per e-mail naar u verstuurd.",
                    stillLockedTitle: "Zit de kabel nog vast?",
                    stillLockedText: "Probeer de kabel opnieuw te ontgrendelen. Blijft hij vastzitten, neem dan contact op met de klantenservice en vermeld:",
                    retry: "Opnieuw ontgrendelen",
                    stationLine: "Laadpaal {{station}} · {{connector}}",
                    transactionLine: "Transactie nr. {{transaction}}",
                },
                connecting: {
                    title: "Verbinden met de laadpaal…",
                    text: "We controleren of de laadpaal klaar is om te starten. Dit duurt enkele seconden.",
                    plugTitle: "Uw voertuig moet aangesloten zijn",
                    plugText: "Sluit, als u dat nog niet gedaan hebt, de kabel aan op de laadpaal en op uw voertuig. Zit de aansluiting achter een klepje, dan wordt het nu ontgrendeld.",
                },
                startFailed: {
                    title: "De laadsessie start niet",
                    subtitle: "Neem contact op met de klantenservice, wij helpen u verder.",
                    noCharge: "Er is niets afgeschreven.",
                    preauthRelease: "De pre-autorisatie van € 40 wordt binnen maximaal 1 uur automatisch geannuleerd.",
                    checklistTitle: "Controleer in de tussentijd",
                    checkCable: "De kabel zit aan beide kanten goed vast",
                    checkSchedule: "Het voertuig staat niet op gepland laden",
                    retry: "Opnieuw proberen te starten",
                },
                charging: {
                    status: "Aan het laden",
                    energyUnit: "kWh geladen",
                    duration: "Duur",
                    pricePerKwh: "Prijs per kWh",
                    canCloseTitle: "U kunt deze pagina sluiten",
                    followLink: "Volg de laadsessie via de link die naar {{email}} is gestuurd",
                    followLinkNoEmail: "Volg de laadsessie via de link die u per e-mail hebt ontvangen",
                    rescan: "Of scan de laadpaal opnieuw en vul de laatste 4 cijfers van uw kaart in",
                    stop: "Laadsessie stoppen",
                    stopping: "Bezig met stoppen…",
                    confirmStopTitle: "Laadsessie stoppen?",
                    confirmStopText: "Alleen de verbruikte energie wordt afgeschreven. Daarna kunt u de kabel ontgrendelen.",
                    confirmStop: "Nu stoppen",
                    cancel: "Doorgaan met laden",
                },
                completed: {
                    title: "Laadsessie beëindigd",
                    amountDebited: "Afgeschreven bedrag",
                    amountPending: "Wordt berekend",
                    energy: "Energie",
                    duration: "Duur",
                    released: "{{amount}} automatisch vrijgegeven, termijn afhankelijk van uw bank",
                    receiptTitle: "Uw betaalbewijs",
                    receiptSent: "Verzonden naar {{email}}. U kunt het ook hier downloaden.",
                    receiptSentNoEmail: "Per e-mail verzonden. U kunt het ook hier downloaden.",
                    receiptPending: "Het wordt naar {{email}} verzonden zodra het beschikbaar is.",
                    receiptPendingNoEmail: "Het wordt per e-mail verzonden zodra het beschikbaar is.",
                    download: "Mijn betaalbewijs downloaden",
                    preparing: "Bezig met downloaden…",
                    unlock: "Kabel ontgrendelen",
                    confirmUnlockTitle: "Kabel ontgrendelen?",
                    confirmUnlockText: "De laadpaal geeft de kabel vrij. Haal hem daarna eerst uit de laadpaal en dan uit uw voertuig.",
                    confirmUnlock: "Ontgrendelen",
                    cancel: "Annuleren",
                    amountPendingReleased: "De rest van de € 40 wordt automatisch vrijgegeven, termijn afhankelijk van uw bank",
                    downloadFailed: "Het downloaden is mislukt. Uw betaalbewijs blijft beschikbaar in de ontvangen e-mail.",
                    retry: "Opnieuw proberen",
                },
            },
            landing: {
                title: "Laden in 3 stappen",
                subtitle: "Zonder account of app.",
                step1Title: "Betaal met uw kaart",
                step1Text: "U betaalt alleen voor de verbruikte energie, tegen het tarief hieronder.",
                step2Title: "Sluit uw voertuig aan",
                step2Text: "Al aangesloten? Perfect. Zit de aansluiting achter een klepje, dan wordt het na bevestiging ontgrendeld.",
                step3Title: "Het laden start",
                step3Text: "Automatisch. U volgt het op deze pagina.",
                yourConnector: "Uw aansluiting",
                chooseConnector: "Kies uw aansluiting",
                continue: "Doorgaan",
            },
            emailStep: {
                title: "Uw e-mailadres",
                subtitle: "Om u de link om de laadsessie te volgen en uw betaalbewijs te sturen.",
                label: "E-mailadres",
                placeholder: "naam@voorbeeld.nl",
                follow: "Uw laadsessie volgen",
                noAccount: "Er wordt geen account aangemaakt",
                consent: "Ik ga akkoord met de <0>Algemene Verkoopvoorwaarden</0> en het <1>Privacybeleid</1>.",
                invalid: "Voer een geldig e-mailadres in, bijvoorbeeld naam@voorbeeld.nl.",
            },
            payment: {
                title: "Betalen met kaart",
                preauth: "<0>€ 40 tijdelijk</0> gereserveerd, <1>niet afgeschreven</1>. Alleen de prijs van uw laadsessie wordt afgeschreven.",
                howItWorks: "Hoe werkt het?",
                yourCard: "Uw kaart",
                secure: "Veilige betaling",
                cardNumber: "Kaartnummer",
                expiry: "Vervaldatum",
                cvc: "CVC",
                acceptedCards: "Franse en buitenlandse kaarten worden geaccepteerd",
                submit: "Bevestigen en starten",
                processing: "Uw kaart wordt gecontroleerd…",
                techError: "Er is een technische fout opgetreden, er is geen bedrag gereserveerd. Probeer het over enkele ogenblikken opnieuw.",
            },
            howItWorks: {
                title: "Een pre-autorisatie, geen betaling",
                subtitle: "Net als bij een tankstation wordt er een bedrag gereserveerd zolang het laden duurt.",
                startTitle: "Bij de start",
                startText: "Uw bank reserveert € 40. Er wordt niets afgeschreven.",
                duringTitle: "Tijdens het laden",
                duringText: "Het laden stopt vanzelf bij € 40.",
                endTitle: "Aan het einde",
                endText: "Alleen de prijs van de laadsessie wordt afgeschreven. De rest wordt automatisch vrijgegeven, <0>binnen een termijn die afhangt van uw bank</0>.",
                example: "Voorbeeld",
                exampleCharged: "12 kWh geladen",
                exampleDebited: "{{amount}} afgeschreven",
                exampleReleased: "Vrijgegeven",
                gotIt: "Begrepen",
            },
            refused: {
                title: "Uw kaart is geweigerd",
                subtitle: "Er is niets afgeschreven.",
                generic: "Uw bank heeft de pre-autorisatie van € 40 niet geaccepteerd. Controleer de limiet van uw kaart of dat online betalen is ingeschakeld.",
                insufficientFunds: "Het saldo of de limiet van uw kaart is onvoldoende om € 40 te reserveren. Probeer een andere kaart of neem contact op met uw bank.",
                expiredCard: "Uw kaart is verlopen. Probeer een andere kaart.",
                incorrectCvc: "De ingevoerde beveiligingscode (CVC) is onjuist. Controleer de 3 cijfers op de achterkant van uw kaart en probeer het opnieuw.",
                authentication: "De bevestiging bij uw bank (3D Secure) is niet voltooid. Probeer het opnieuw en bevestig de betaling in de app van uw bank.",
                tryAnother: "Andere kaart proberen",
                useApp: "De Qovoltis-app gebruiken",
                needHelp: "Hulp nodig?",
            },
            invoice: {
                title: "Factuur op naam",
                intro: "Deze gegevens komen op uw factuur, die naar {{email}} wordt gestuurd.",
                introNoEmail: "Deze gegevens komen op uw factuur, die per e-mail wordt gestuurd.",
                lastName: "Achternaam",
                firstName: "Voornaam",
                address: "Adres",
                addressPlaceholder: "12 rue de la Paix, 75002 Paris",
                required: "* Verplichte velden",
                fieldRequired: "Verplicht veld",
                addressPick: "Kies een adres uit de lijst.",
                save: "Opslaan",
                noInvoice: "Ik wil geen factuur",
                noInvoiceTitle: "Doorgaan zonder factuur?",
                noInvoiceText: "U ontvangt alleen een betaalbewijs per e-mail. U kunt voor deze laadsessie geen factuur op naam meer krijgen.",
                noInvoiceConfirm: "Ja, doorgaan zonder factuur",
                cancel: "Annuleren",
                needInvoice: "Factuur op naam nodig?",
                addDetails: "Mijn gegevens toevoegen",
                saved: "Uw gegevens komen op uw factuur.",
                saveError: "Uw gegevens konden niet worden opgeslagen.",
                savedDetail: "{{name}} · {{address}}",
                retry: "Opnieuw proberen",
            },
            language: {
                title: "Taal",
                new: "Nieuw",
            },
            loadingStation: {
                title: "Laadpaal wordt geladen…",
                text: "We halen de aansluitingen en het tarief op.",
            },
            linkLoading: {
                title: "Uw laadsessie wordt geladen…",
                text: "De link uit uw e-mail om de laadsessie te volgen wordt geopend.",
            },
            ineligible: {
                title: "Deze laadpaal accepteert geen betaling met kaart",
                text: "U kunt hem in enkele minuten starten via de Qovoltis-app.",
            },
            errorPage: {
                text: "Er is geen bedrag afgeschreven. Probeer het opnieuw of scan de QR-code van de laadpaal opnieuw.",
                retry: "Opnieuw proberen",
            },
            notFoundPage: {
                title: "Pagina niet gevonden",
                text: "Dit adres hoort bij geen enkele laadpaal. Scan de QR-code op de laadpaal opnieuw.",
            },
            linkInvalid: {
                text: "Om een lopende laadsessie terug te vinden, scant u de laadpaal opnieuw en voert u de laatste 4 cijfers van uw kaart in.",
            },
            resumeList: {
                subtitle: "Er lopen meerdere laadsessies op deze laadpaal. Kies de aansluiting waarop uw voertuig is aangesloten.",
            },
            busy: {
                title: "Deze aansluiting is bezet",
                subtitle: "Er loopt een laadsessie op deze laadpaal.",
                yoursTitle: "Is dit uw laadsessie?",
                yoursText: "Volg of stop hem vanaf uw telefoon.",
                find: "Mijn laadsessie terugvinden",
                later: "Scan anders de laadpaal opnieuw zodra de aansluiting vrij is.",
            },
            intent: {
                title: "Wat wilt u doen?",
                subtitle: "Er loopt al een laadsessie op deze laadpaal.",
                startTitle: "Laadsessie starten",
                startText: "Er is een aansluiting beschikbaar",
                resumeTitle: "Mijn laadsessie hervatten",
                resumeText: "De lopende laadsessie volgen of stoppen",
            },
            common: {
                back: "Terug",
                close: "Sluiten",
            },
            steps: {
                connector: "Aansluiting",
                email: "E-mail",
                payment: "Betaling",
            },
            panel: {
                station: "Uw laadpaal",
                summary: "Overzicht",
                charge: "Uw laadsessie",
                address: "Adres",
                connector: "Aansluiting",
                rate: "Tarief",
                preauth: "Pre-autorisatie",
                preauthValue: "€ 40 gereserveerd, niet afgeschreven",
                connectorsCount: "{{count}} aansluitingen",
            },
            support: {
                whatsapp: "Klantenservice een bericht sturen",
                call: "Klantenservice bellen",
                orCall: "Of bel de klantenservice",
                whatsappMessage: "Hallo, ik heb hulp nodig bij mijn laadsessie. Laadpaal {{station}}, aansluiting {{connector}}, {{time}}.",
                whatsappMessageTransaction: "Hallo, ik heb hulp nodig bij mijn laadsessie. Laadpaal {{station}}, aansluiting {{connector}}, laadsessie {{transaction}}, {{time}}.",
            },
            downloadApp: {
                title: "Beheer uw laadsessies eenvoudiger met onze app",
                description: "Volg uw laadsessies, bekijk uw facturen en vind eenvoudig laadpalen in de buurt, rechtstreeks op uw smartphone.",
                downloadButton: "App downloaden",
                continueWithoutApp: "Doorgaan zonder app",
                features: {
                    feature1: "Laden met één klik",
                    feature2: "Uw verbruik volgen",
                    feature3: "Alle laadpalen vinden",
                    feature4: "Profiteer van exclusieve aanbiedingen",
                },
            },
            errorTitle: "Fout!",
            genericErrorTitle: "Er is een fout opgetreden",
            genericErrorMessage: "Fout bij het aanmaken van uw autorisatie. Probeer het opnieuw.",
            errorIconAlt: "Foutpictogram",
            pageNotFound: "Pagina niet gevonden of ongeldig serienummer",
            noBorneData: "Gegevens van de laadpaal ontbreken.",
            errors: {
                badRequest: "Het verzoek is ongeldig. Controleer de ingevulde gegevens.",
                unauthorized: "U bent niet gemachtigd om deze actie uit te voeren. Meld u opnieuw aan.",
                forbidden: "Toegang geweigerd. U hebt niet de benodigde rechten.",
                notFound: "De gevraagde bron is niet gevonden.",
                requestTimeout: "Het verzoek is verlopen. Probeer het opnieuw.",
                conflict: "Er is een conflict vastgesteld. Vernieuw de pagina en probeer het opnieuw.",
                validationError: "De ingevulde gegevens zijn ongeldig. Controleer de velden.",
                tooManyRequests: "Te veel pogingen. Probeer het later opnieuw.",
                serverError: "De server heeft een technisch probleem. Probeer het later opnieuw.",
                badGateway: "Er is een communicatieprobleem tussen servers opgetreden. Probeer het later opnieuw.",
                serviceUnavailable: "De dienst is tijdelijk niet beschikbaar. Probeer het later opnieuw.",
                gatewayTimeout: "De server reageerde te traag. Probeer het later opnieuw.",
                networkError: "Netwerkprobleem. Controleer uw internetverbinding en probeer het opnieuw.",
                unknownError: "Er is een onverwachte fout opgetreden. Probeer het later opnieuw.",
                methodNotAllowed: "De verzoekmethode is niet toegestaan voor deze bron.",
                invoiceError: "Er is een fout opgetreden bij het verzenden van de factuur. Probeer het opnieuw.",
                chargingStationNotFound: "Laadpaal niet gevonden",
                stripeError: "Er is een fout opgetreden bij het verwerken van uw betaling. Controleer uw gegevens en probeer het opnieuw.",
                recaptchaFailed: "De beveiligingscontrole is mislukt. Probeer het opnieuw.",
                recaptchaExpired: "De beveiligingscontrole is verlopen. Probeer het opnieuw.",
                chargingFailed: "Het starten van de laadsessie is mislukt. Probeer het opnieuw of neem contact op met de klantenservice.",
                invalidResponse: "Netwerkfout of ongeldig antwoord van de server.",
                authorizationFailed: "De betalingsautorisatie kon niet worden aangemaakt.",
                paymentInitFailed: "De beveiligde betaling kon niet worden voorbereid. Probeer het opnieuw.",
                insufficientFunds: "Deze kaart kan niet worden gebruikt wegens onvoldoende saldo. Probeer een andere kaart.",
                errorAttachingPayment: "Er is een fout opgetreden bij het opslaan van uw betaalmiddel. Probeer het opnieuw.",
                cardDeclined: "Uw kaart is geweigerd. Controleer uw gegevens of gebruik een andere kaart.",
                expiredCard: "Uw kaart is verlopen. Gebruik een geldige kaart.",
                incorrectCvv: "De beveiligingscode (CVV) is onjuist. Controleer hem en probeer het opnieuw.",
                processingError: "Er is een fout opgetreden bij het verwerken van uw verzoek. Probeer het opnieuw.",
                emailRequired: "Vul uw e-mailadres in.",
                emailInvalid: "Vul een geldig e-mailadres in",
                invalidEmail: "Vul een geldig e-mailadres in.",
                apiError: "❌ Er is een fout opgetreden. Probeer het opnieuw.",
                stripeCustomerNotFound: "Uw Stripe-klant is niet gevonden en kon niet opnieuw worden aangemaakt",
                countryNotFound: "Het opgegeven land is niet gevonden",
                postalCodeNotFound: "De opgegeven postcode is niet gevonden",
                noOngoingTransaction: "Geen lopende laadsessie gevonden voor deze gebruiker",
                transactionClosed: "Deze laadsessie is al afgesloten",
                noAuthorizationFound: "Geen creditcardautorisatie gevonden voor deze laadsessie",
                authorizationNotFound: "De opgegeven autorisatie is niet gevonden",
                authorizationNotFoundInDB: "De opgegeven autorisatie is niet gevonden in de database",
                updatingAuthorizationError: "Er is een fout opgetreden bij het bijwerken van de autorisatie",
                noDefaultCreditCard: "De gebruiker heeft geen standaardcreditcard",
                evcpNotFound: "De opgegeven laadpaal is niet gevonden",
                connectorNotFound: "De opgegeven aansluiting is niet gevonden op deze laadpaal",
                useridTagNotFound: "Gebruikers-ID niet gevonden",
                failedAssociateUser: "De gebruiker kon niet worden gekoppeld",
                internalError: "Interne fout. Probeer het opnieuw",
                noOngoingCpSession: "Er loopt geen laadsessie voor deze gebruiker. Controleer of de laadpaal online is en uw sessie geldig is",
                remoteStartDenied: "Starten op afstand geweigerd",
                kafkaError: "Onverwachte fout bij het verzenden naar Kafka",
                transactionNotAssociated: "De laadsessie hoort niet bij de opgegeven laadpaal",
                cpDisconnected: "De laadpaal is niet verbonden",
            },
            access_denied_no_session: "Toegang geweigerd: geen laadsessie gevonden.",
            notEligibleForOneClick: "Deze laadpaal ondersteunt Scan to Charge niet. Download onze app om verder te gaan.",
            storeRedirect: {
                downloadTitle: "Download onze app",
                downloadDescription: "Download de Qovoltis-app voor een betere ervaring.",
            },
            sessionChoice: {
                title: "Er loopt een laadsessie op deze laadpaal",
                question: "Wat wilt u doen?",
                startNew: {
                    title: "Nieuwe laadsessie starten",
                    description: "Kies een beschikbare aansluiting en sluit uw voertuig aan.",
                    noConnectorAvailable: "Er is op dit moment geen aansluiting beschikbaar op deze laadpaal.",
                },
                resume: {
                    title: "Mijn lopende laadsessie hervatten",
                    description: "Volg of stop de laadsessie die u al hebt gestart.",
                },
            },
            resumeSession: {
                findTitle: "Mijn laadsessie terugvinden",
                findSubtitle: "Vul de laatste 4 cijfers in van de kaart waarmee u hebt betaald.",
                emailLinkHint: "U kunt ook de link uit de e-mail gebruiken.",
                access: "Naar mijn laadsessie",
                digitLabel: "Cijfer {{position}} van 4",
                title: "Laadsessie hervatten",
                sessionActive: "Er loopt een laadsessie op deze aansluiting.",
                cta: "Mijn laadsessie hervatten",
                cardLabel: "Vul de laatste 4 cijfers in van de gebruikte kaart",
                validate: "Bevestigen",
                verifying: "Bezig met controleren...",
                errors: {
                    invalidFormat: "Vul de laatste 4 cijfers van uw kaart in.",
                    wrongCard: "Onjuiste code. U hebt nog {{count}} poging(en).",
                    tooManyAttempts: "Te veel pogingen. Probeer het later opnieuw.",
                    wrongDigits: "Deze cijfers komen niet overeen met de lopende laadsessie. Controleer de gebruikte kaart.",
                    missingInfo: "Sessiegegevens ontbreken.",
                    invalidLink: "Deze link is ongeldig of verlopen.",
                    generic: "Er is een fout opgetreden. Probeer het opnieuw.",
                },
            },
            chargingStarted: "Laadsessie succesvol gestart",
            chargingStationInfo: "Gegevens van de laadpaal",
            connectorInfo: "Gegevens van de aansluiting",
        }
    },
};

export default translations;